
/* ── BB SAMPLES (2026-08-11) ──────────────────────────────────────────────────
   Samples sit in their own free delivery profile, so they must not count toward
   the freight rate, the $500 order minimum, or the lead-time ETA. Identify a
   sample line by the hidden property the PDP button stamps on it, with a variant
   -id fallback, then subtract those lines before any freight maths runs. */
function bbIsSampleLine(it){
  if (!it) return false;
  var p = it.properties || {};
  if (p._src_handle || p['Sample of']) return true;
  return String(it.variant_id) === '48060808298715' || String(it.variant_id) === '50913267450157';
}
function bbFreightCents(cart){
  var t = (cart && cart.total_price) || 0;
  var items = (cart && cart.items) || [];
  for (var i = 0; i < items.length; i++){
    if (bbIsSampleLine(items[i])){
      var lp = (items[i].final_line_price != null) ? items[i].final_line_price : items[i].line_price;
      t -= (lp || 0);
    }
  }
  try { window.__bbSampleCents = ((cart && cart.total_price) || 0) - Math.max(0, t); } catch(_e){}
  return Math.max(0, t);
}
function bbSampleOnly(cart){
  var items = (cart && cart.items) || [];
  if (!items.length) return false;
  for (var i = 0; i < items.length; i++){ if (!bbIsSampleLine(items[i])) return false; }
  return true;
}
/* Sample-only cart: the freight card has nothing true to say, so replace it. */
function bbApplySampleOnly(cart){
  try {
    var only = bbSampleOnly(cart);
    document.documentElement.classList.toggle('bb-sample-only-cart', only);
    var cards = document.querySelectorAll('[id^="bb-ship-"]');
    for (var i = 0; i < cards.length; i++){
      var el = cards[i];
      if (!only){
        if (el.dataset.bbSampleSwapped === '1'){ el.innerHTML = el.dataset.bbSampleOrig || ''; el.dataset.bbSampleSwapped = '0'; }
        continue;
      }
      if (el.dataset.bbSampleSwapped === '1') continue;
      el.dataset.bbSampleOrig = el.innerHTML;
      el.dataset.bbSampleSwapped = '1';
      el.innerHTML = '<div style="border:1px solid #EB673C;border-radius:10px;padding:14px 16px;text-align:center;line-height:1.45">'
        + '<div style="font-weight:800;letter-spacing:.04em">YOUR SAMPLE SHIPS FREE</div>'
        + '<div style="opacity:.75;font-size:14px;margin-top:2px">12&quot; x 12&quot; piece &middot; no order minimum</div>'
        + '<div style="margin-top:6px;font-weight:700">$50 credited back to your account when it ships</div>'
        + '</div>';
    }
  } catch (_e) {}
}

/**
 * BarrierBoss Shipping Estimator — USA Store (Gamified)
 * Progress bars, tier unlocks, celebration states
 * Fires GA4 custom events for conversion tracking (no Shopify Plus required)
 */
(function() {
  // US states → zone mapping (RESHUFFLE 2026-06-12, demand-balanced regional zones)
  // 1=Pacific Northwest, 2=Mountain West, 5=Southwest, 6=California
  // 3=East Coast (PAUSED), 4=Mid States (PAUSED)
  // QUICK SHIP CONTIGUOUS EXPANSION 2026-08-12 — zones 3/4/7 are NEWLY OPENED for the
  // Loose Truck lane only (unframed black/silver/brown hog wire, deck railing, cattle panel,
  // hog track kit, standalone panels). They mirror the live checkout profile
  // "Loose Truck — Contiguous" (USA 114604474587). CRANE remains WEST-ONLY.
  // 1=Northwest 2=Rockies 5=Southwest 6=California | 3=Atlantic & Deep South 4=Plains 7=Midwest & Mid-South
  // ⛔ ARKANSAS IS DELIBERATELY ABSENT — owner: "arkansas we arent allowed into in general."
  //    Never add AR to a zone. Its absence is correct, not an oversight.
  // ⛔ AK / HI / PR and the territories are absent for the same reason: no rate = no checkout.
    // ⭐⭐ THE STANDARD CARD, live 2026-10-21. ONLY the kept regions appear here. A region with
  //    no entry has no zone, no rate and no quote — which is the point: checkout refuses it too.
  //    The four zones remain because each 2027 hub will get its OWN four measured from itself;
  //    today they all carry the same price.
  // ⛔ Never add a paused region here without also adding it to the live delivery profiles.
  var ZONES = {
    'WA':1,'OR':1,'ID':1,
    'MT':2,'NV':2,'UT':2,'WY':2,'CA':2,
    'AZ':3,'CO':3,'NM':3,
    'TX':4,
    'CT':4,'DE':4,'DC':4,'FL':4,'GA':4,'IL':4,'IN':4,'IA':4,'KS':4,'KY':4,'LA':4,'ME':4,'MD':4,'MA':4,'MI':4,'MN':4,'MS':4,'MO':4,'NE':4,'NH':4,'NJ':4,'NY':4,'NC':4,'ND':4,'OH':4,'OK':4,'PA':4,'RI':4,'SC':4,'SD':4,'TN':4,'VT':4,'VA':4,'WV':4,'WI':4
  }

  // ⭐⭐ LANE-AWARE PAUSE 2026-08-12. This map used to pause EVERYTHING in these states.
  // It is now CRANE-ONLY: Loose Truck reaches every state in ZONES, but the crane truck still
  // runs West-only until the hubs exist. A visitor in zone 3/4/7 must therefore see a REAL
  // Loose Truck rate for unframed panels, and a "ships to you as Unframed instead" nudge — never
  // a flat "we don't deliver here", which is now false and costs us the order.
  // ⛔ Do NOT reintroduce a global pause: checkout WILL accept these states for the Loose Truck
  //    profile, so a global pause makes the storefront contradict the cart.
    /* ⭐⭐ REPOPULATED 2026-10-21. THE WARNING THAT USED TO SIT HERE IS NOW REVERSED.
     It read: "Checkout quotes Crane Truck to every one of these states, so any entry here
     makes the storefront contradict the cart. Do NOT repopulate."
     That was true until 2026-10-21. On that date every region below was removed from every zone
     of every delivery profile, so CHECKOUT NOW QUOTES NOTHING for them. An entry here is what
     makes the storefront AGREE with the cart. Left in place, the old note would have stopped the
     next reader doing the correct thing — the header, the PDP chip and the delivery box were all
     quoting "$349 Flat" to New York while the cart refused the order.
     ⛔ The rule that still holds: this list and the live profiles must match. Change both or
        neither. Never-served regions stay in UNSERVED_STATES, which renders a dateless message. */
  var CRANE_PAUSED_STATES = {
    'CT':1,
    'DE':1,
    'DC':1,
    'FL':1,
    'GA':1,
    'IL':1,
    'IN':1,
    'IA':1,
    'KS':1,
    'KY':1,
    'LA':1,
    'ME':1,
    'MD':1,
    'MA':1,
    'MI':1,
    'MN':1,
    'MS':1,
    'MO':1,
    'NE':1,
    'NH':1,
    'NJ':1,
    'NY':1,
    'NC':1,
    'ND':1,
    'OH':1,
    
    'PA':1,
    'RI':1,
    'SC':1,
    'SD':1,
    'TN':1,
    'VT':1,
    'VA':1,
    'WV':1,
    'WI':1
  }
  // States with NO service at all (no Loose Truck, no crane) — these keep the old paused notice.
  var UNSERVED_STATES = { 'AL':1,'AR':1,'AK':1,'HI':1,'PR':1,'GU':1,'VI':1,'AS':1,'MP':1 };   // AL added 2026-09-17: owner "we cant ship to arkansas and AL"
  /* PAUSED 2026-10-21. These stay IN ZONES so geoZone is never null — removing them made
     renderElement bail on its first line and the estimator block VANISHED on a paused ZIP.
     Folded into UNSERVED_STATES so the existing notice branch renders them; only its copy differs. */
  var PAUSED_REGIONS = { 'CT':1, 'DE':1, 'DC':1, 'FL':1, 'GA':1, 'IL':1, 'IN':1, 'IA':1, 'KS':1, 'KY':1, 'LA':1, 'ME':1, 'MD':1, 'MA':1, 'MI':1, 'MN':1, 'MS':1, 'MO':1, 'NE':1, 'NH':1, 'NJ':1, 'NY':1, 'NC':1, 'ND':1, 'OH':1,  'PA':1, 'RI':1, 'SC':1, 'SD':1, 'TN':1, 'VT':1, 'VA':1, 'WV':1, 'WI':1 };
  for (var _prK in PAUSED_REGIONS) { if (Object.prototype.hasOwnProperty.call(PAUSED_REGIONS, _prK)) UNSERVED_STATES[_prK] = 1; }
  try {
    window.BB_PAUSED_REGIONS = PAUSED_REGIONS;
    /* ⛔ The banner reads BB_PAUSED_STATES / BB_PAUSED_PROVINCES and falls back only when they
       are FALSY. The old assignment handed it an EMPTY object, which is truthy, so the bar
       could never show a pause. Publish the real set under both names. */
    window.BB_PAUSED_STATES = PAUSED_REGIONS;
    window.BB_PAUSED_PROVINCES = PAUSED_REGIONS;
  } catch (_pe) {}
  // Back-compat: legacy readers (banner, PDP) still reference PAUSED_STATES. It now means
  // "paused for the CRANE lane", which is what every existing consumer actually renders.
  var PAUSED_STATES = CRANE_PAUSED_STATES;
  var PAUSE_CTA_URL = '/pages/new-facilities#reserve'; // lands on the non-binding waitlist form
  // Per-state reopen [when, hub] — sourced from the PUBLISHED /pages/new-facilities
  // hub schedule: Washington Q3 2027 (Pacific NW), Arizona Q4 2027 (Southwest/Mid-States),
  // Georgia Q1 2028 (Southeast), Pennsylvania Q2 2028 (Northeast/Mid-Atlantic). Keep in sync
  // with /pages/new-facilities AND the facilities block in templates/page.contact.json.
  var RESUME_INFO = {
    'NE':['Q4 2027','Arizona'],'ND':['Q4 2027','Arizona'],'SD':['Q4 2027','Arizona'],'IL':['Q4 2027','Arizona'],'MO':['Q4 2027','Arizona'],'IA':['Q4 2027','Arizona'],'LA':['Q4 2027','Arizona'],'MN':['Q4 2027','Arizona'],'WI':['Q4 2027','Arizona'],'KS':['Q4 2027','Arizona'],
    'AR':['Q4 2027','Arizona'],
    'MS':['Q1 2028','Georgia'],'AL':['Q1 2028','Georgia'],'GA':['Q1 2028','Georgia'],'FL':['Q1 2028','Georgia'],'TN':['Q1 2028','Georgia'],'KY':['Q1 2028','Georgia'],'SC':['Q1 2028','Georgia'],'NC':['Q1 2028','Georgia'],'PR':['Q1 2028','Georgia'],
    'VA':['Q2 2028','Pennsylvania'],'WV':['Q2 2028','Pennsylvania'],'MD':['Q2 2028','Pennsylvania'],'DC':['Q2 2028','Pennsylvania'],'DE':['Q2 2028','Pennsylvania'],'NJ':['Q2 2028','Pennsylvania'],'PA':['Q2 2028','Pennsylvania'],'NY':['Q2 2028','Pennsylvania'],'CT':['Q2 2028','Pennsylvania'],'MA':['Q2 2028','Pennsylvania'],'VT':['Q2 2028','Pennsylvania'],'NH':['Q2 2028','Pennsylvania'],'ME':['Q2 2028','Pennsylvania'],'RI':['Q2 2028','Pennsylvania'],'MI':['Q2 2028','Pennsylvania'],'OH':['Q2 2028','Pennsylvania'],'IN':['Q2 2028','Pennsylvania']
  };
  try { /* ⛔ removed: re-published the EMPTY CRANE_PAUSED_STATES over the real set */ window.BB_RESUME_INFO = RESUME_INFO; } catch (e) {}

    // ⭐ Distance-based names, not geographic: when the AZ/GA/PA hubs open, each gets its own
  //    four zones measured from itself, so "Zone 2 — Near" stays true from any origin.
  var ZONE_NAMES = {
    1: 'Zone 1 — Home',
    2: 'Zone 2 — Near',
    3: 'Zone 3 — Far',
    4: 'Zone 4 — Furthest'
  }

  // Production + transit by zone (days)
  // Zone 1 (Local): 3 wk prod + 2 days transit | Zone 2 (WCE): 3 wk prod + 1 wk transit
  // Zone 5 (WC Standard): 3 wk prod + 1 wk transit | Zone 4 (Mid States): 3 wk prod + 4 wk transit
  // Zone 3 (East Coast): 3 wk prod + 5 wk transit
  var ZONE_PRODUCTION = { 1: 21, 2: 21, 3: 21, 4: 21, 5: 21, 6: 21, 7: 21 };
  var ZONE_TRANSIT = { 1: 2, 2: 7, 3: 35, 4: 14, 5: 7, 6: 7, 7: 21 };
  // Base customer-facing ETA per zone, days [min,max].
  // ⭐ 2026-08-12 owner: lead time now varies by distance — "farthest is 6-8 weeks".
  //    West 2-4 wk (unchanged) · Plains 3-5 · Midwest & Mid-South 4-6 · Atlantic & Deep South 6-8.
  // ⛔ This BREAKS the old flat `_LT = [42,56,14,28]` everywhere-the-same model. The flat array
  //    below is still used for the WEST; zones 3/4/7 must read from here.
  // ⭐⭐ FLAT ACROSS ZONES, owner 2026-10-21: "the lead times will all be the same for these
  //    zones, it's just the distance the truck has to cover" — a Texas drop rides the California
  //    run. The MEASUREMENT agrees: per-state order-to-ship medians show NO distance signal
  //    (MT 512mi = 23bd is the FASTEST; NM 1,239mi = 50bd the slowest). The wait is the build
  //    queue, not the drive, so the rate is flat and the promise is flat.
  //    Heavy = 20-30 business days = 4-6 weeks.
  var ZONE_ETA = { 1: [10,30], 2: [10,30], 3: [10,30], 4: [10,30] };   /* 2-6 wks, EVERY zone, ONE lane (owner 2026-11-01) */
  // Loose Truck lead time per zone, days [min,max] — what an UNFRAMED panel actually takes.
  // STANDARD 2-4 wks = the 13 crane-core states (zones 1,2,5,6). EXTENDED 6-8 wks = everything
  // else (owner 2026-08-13). Zone 4 was 3-5 and zone 7 was 4-6 — both under-promised the date.
  var ZONE_QS_ETA = { 1: [10,30], 2: [10,30], 3: [10,30], 4: [10,30] };   /* 2-6 wks, EVERY zone, ONE lane (owner 2026-11-01) */
  // Special order adds ANOTHER 4-6 weeks production ON TOP of the zone ETA (Model B).
  var SO_ADD_MIN = 42, SO_ADD_MAX = 56;
  var bbSO = false;
  // ── LOOSE-LIGHT ETA: unframed wire panels (hog/cattle/deck railing) = Loose Truck 2-4 wks. Read LIVE from DOM. ──
  var bbHogWire=false,bbUnframedInit=false;
  (function(){var el=document.getElementById('bb-ship-est-product');if(el){bbHogWire=el.getAttribute('data-bb-hogwire')==='true';bbUnframedInit=el.getAttribute('data-bb-init-unframed')==='true';}})();
  function bbIsUnframedNow(){
    if(!bbHogWire)return false;
    var fr=/unframed|just the (metal|wire)/i, frm=/pressure treated|cedar|full metal/i;
    var r=document.querySelectorAll('input[type="radio"]:checked');
    for(var i=0;i<r.length;i++){var v=r[i].value||'';if(fr.test(v))return true;if(frm.test(v))return false;}
    var s=document.querySelectorAll('select');
    for(var j=0;j<s.length;j++){if(s[j].selectedIndex<0)continue;var o=s[j].options[s[j].selectedIndex];if(!o)continue;var ov=o.value||o.textContent||'';if(fr.test(ov))return true;if(frm.test(ov))return false;}
    var sel=document.querySelectorAll('[aria-checked="true"],.is-selected,[data-selected="true"]');
    for(var k=0;k<sel.length;k++){var sv=sel[k].value||sel[k].textContent||'';if(fr.test(sv))return true;if(frm.test(sv))return false;}
    return bbUnframedInit;
  }
  var bbFrDeb;
  function bbPublishEta(){try{var d=getShipDates(0);var a=d.range||d.arrive||'';var s=(function(x){var m=(x||'').match(/^([A-Za-z]+) (\d+)\s*[–-]\s*([A-Za-z]+) (\d+)$/);return m?(m[1]===m[3]?m[1]+' '+m[2]+'–'+m[4]:m[1]+' '+m[2]+'–'+m[3]+' '+m[4]):x;})(a);if(s)window.BB_ETA={etaStr:s};}catch(e){}}
  function bbReeval(){clearTimeout(bbFrDeb);bbFrDeb=setTimeout(function(){try{refreshFromCart();}catch(_){}bbPublishEta();},120);}
  try{bbPublishEta();}catch(e){}
  document.addEventListener('DOMContentLoaded',function(){try{bbPublishEta();}catch(e){}});
  document.addEventListener('change',bbReeval,true);
  document.addEventListener('on:variant:change',bbReeval);

  // Rates in USD cents. Edit a ladder here and the PDP estimator, slide-cart and header
  // banner all follow.
  // FOUR DISTANCE BANDS, live 2026-10-05. ONE rate per zone, every cart value — the seven
  // elements of a ladder are deliberately identical, and NONE of them is 0.
  // ⭐⭐ STEPPED LADDER, live 2026-10-26: $149/$199 -> $49/$99 -> FREE at $3,500. The 0 bands
  //    are INTENTIONAL and mirror checkout. ⛔ The old "there is no free tier, never use a 0"
  //    rule belonged to the retired flat card — do NOT restore it. There is still no order
  //    minimum. ⚠️ FREE must never render in a PAUSED region; the zone gate handles that.
  // ⛔ The seven bands exist only because the ladder shape is shared with the banner, the
  //    configurator and the freight finder. Flatten a ladder by setting all seven, never by
  //    shortening it.
  // ⛔ ORDER MINIMUMS, live 2026-10-16 (owner). Z1 $250 · Z2 $500 · Z3 $750 · Z4 $1000.
  //    A minimum is the ABSENCE OF A RATE: below it checkout quotes nothing and the cart
  //    cannot complete. It is NOT a surcharge.
  // ⭐ DERIVED FROM THE ZONE'S OWN RATE, never a second zone list — the rate IS the distance
  //    band, so a reprice moves the minimum with it. Mirrors the live checkout floors.
  // ⛔ Bands are clamped UP to the floor: getCurrentTierIndex scans top-down and returns the
  //    first tier the cart clears, so a band below the floor would quote under the minimum.
  // ⛔⛔ THERE IS NO ORDER MINIMUM. All 16 TOTAL_PRICE conditions were DELETED from both
  //    stores' delivery profiles on 2026-10-21 (owner). A sub-$250 cart now quotes and completes
  //    at the full flat rate. Keep these 0 — a non-zero value re-creates a floor the cart no
  //    longer has, and the storefront would refuse an order checkout accepts.
  /* ⭐ $500 ORDER MINIMUM, live 2026-10-26. This map sets the FIRST band's min, so a non-zero
     value here is what makes _dpMin real and re-enables the _belowMin branch everywhere. */
  var _BB_MIN_FOR_RATE = { 99: 50000, 49: 50000, 149: 50000, 199: 50000, 249: 50000, 299: 50000, 349: 50000, 399: 50000, 449: 50000, 499: 50000 };
  var _BB_BANDS = [50000, 250000, 500000, 500000, 1000000, 1500000, 2500000]; // cents
  /* ⛔⛔ THE TWO LANES STEP AT DIFFERENT CART VALUES — Light at $1,000, HEAVY at $1,500 — and one
     shared band array cannot express that. Using _BB_BANDS for CRANE_RATES quoted $99 from $1,000
     while checkout still billed $199 until $1,500, so the storefront UNDER-quoted every heavy cart
     in that range. Heavy gets its own bands; _bbLH is _bbL against them. */
  /* ⛔ Both lanes step at $2,500 under the approved card, so these now MATCH _BB_BANDS. They
     diverged earlier today and that divergence quoted heavy $99 from $1,000 while checkout billed
     $199 to $1,499. Kept as its own array so a future lane split has somewhere to go. */
  var _BB_BANDS_HEAVY = [50000, 250000, 500000, 500000, 1000000, 1500000, 2500000]; // cents
  // ⭐ index 2 is $3,500 — the live FREE threshold. _bbL maps index 0 to $0 via
  //    _BB_MIN_FOR_RATE, so the effective bands are [0, 1k, 3.5k, 5k, 10k, 15k, 25k].
  function _bbL(d){
    var _m0 = _BB_MIN_FOR_RATE[d[0]];
    if (_m0 == null) _m0 = _BB_BANDS[0];   // unknown rate -> the old $500 floor, never 0
    return d.map(function (v, i) {
      return { min: (i === 0 ? _m0 : Math.max(_m0, _BB_BANDS[i])), rate: v * 100, label: v === 0 ? 'FREE' : '$' + v };
    });
  }
  function _bbLH(d){
    var _m0 = _BB_MIN_FOR_RATE[d[0]];
    if (_m0 == null) _m0 = _BB_BANDS_HEAVY[0];
    return d.map(function (v, i) {
      return { min: (i === 0 ? _m0 : Math.max(_m0, _BB_BANDS_HEAVY[i])), rate: v * 100, label: v === 0 ? 'FREE' : '$' + v };
    });
  }
  // QUICK SHIP ladder. Mirrors the live checkout profiles exactly:
  //   General 104899805403 (west) + Loose Truck — Contiguous 114604474587 (all zones).
    // ⭐⭐ ONE STANDARD RATE: $149 Light in EVERY zone, live 2026-10-21. Owner: "one standardized
  //    zone feel" — these rates already work in the close regions, so applying them to the
  //    furthest grows volume there and fills the loop. DENSITY is the only lever that moves cost
  //    per stop hard: 118 stops/mo = $151/stop, double it = $76, triple it = $50.
  // ⛔ NOT the retired flat-$149 card — there is NO free-over-$5,000 tier and NO order minimum.
  // ⭐⭐ STEPPED LADDER, live 2026-10-26. The zero bands are INTENTIONAL and mirror the
  //    live checkout tiers — bb-mobile-atc.js SHOULD render its "FREE" row above $3,500.
  //    ⛔ The old "NONE is 0" rule was for the flat card and is now wrong; do not restore it.
  //    ⚠️ FREE must still never appear in a PAUSED region — the zone gate handles that.
  var RATES = {
    1: _bbL([ 149, 0, 0, 0, 0, 0, 0 ]),
    2: _bbL([ 149, 0, 0, 0, 0, 0, 0 ]),
    3: _bbL([ 149, 0, 0, 0, 0, 0, 0 ]),
    4: _bbL([ 149, 0, 0, 0, 0, 0, 0 ])
  }

  // SINGLE SOURCE OF TRUTH (2026-05-26): the header banner (bb-dynamic-banner.js)
  // reads this instead of keeping its own copy, so one edit here updates the
  // PDP estimator, slide-cart estimator, AND the header rotating bar.
  
  // CRANE freight ladder (added 2026-07-27) — mirrors the live Crane delivery profile.
  // CRANE ladder — mirrors the live Crane profile (114291540187), which is WEST-ONLY.
  // ⛔ Zones 3/4/7 have NO crane rate at all. Do not invent one: checkout will not offer crane
  //    there, so quoting a price would be a promise we cannot keep. Use CRANE_SERVED to branch.
    // ⭐⭐ ONE STANDARD RATE: $199 Heavy/crane in EVERY zone, live 2026-10-21.
  var CRANE_RATES = {
    1: _bbLH([ 149, 0, 0, 0, 0, 0, 0 ]),
    2: _bbLH([ 149, 0, 0, 0, 0, 0, 0 ]),
    3: _bbLH([ 149, 0, 0, 0, 0, 0, 0 ]),
    4: _bbLH([ 149, 0, 0, 0, 0, 0, 0 ])
  }
  // Which zones the crane truck actually reaches. Zones 3/4/7 = Loose Truck only.
  var CRANE_SERVED = { 1:1, 2:1, 3:1, 4:1 };   // crane reaches all four kept zones
  function bbCraneServed(z){ return !!CRANE_SERVED[z]; }

  // ⭐ INVARIANT (owner 2026-08-13): "if we serve both quick and crane, that's our standard zone."
  // Lead time is therefore DERIVED from crane coverage, never maintained as a second list — two
  // hand-kept tables are what showed Ontario 4-6 weeks and BC/AB "1-2 weeks" (faster than real).
  // Standard = Loose Truck 2-4 wks (crane itself is 6-8). Extended = Loose Truck 6-8, no crane.
  // ⭐ TWO TIERS, derived from crane coverage — never a second hand-kept list.
  //   EXPRESS  = crane-served: Loose Truck 2-4 wks, Crane 6-8 wks
  //   EXTENDED = not crane-served: Loose Truck 6-8 wks, no crane (crane there would be ~3 months)
  // A distance-based express tier was tested and dropped: the closest zones actually fulfil
  // SLOWER than the farther ones (75d medians: WA/OR 38d, BC 31d vs Rockies/Southwest 19d), so
  // km does not predict lead time and a 1-2 week promise would have missed ~80% of the time.
  (function bbApplyLeadTimes(){
    /* ⛔ 2026-08-16: lead time is NO LONGER derived from crane coverage. That rule assumed
       crane == the West; once crane opened to the contiguous territory every zone read as
       "express" and the storefront promised extended customers 2-4 weeks instead of the real
       figure. Lead time is now an EXPLICIT per-zone table — do not reintroduce a derivation. */
    try {
      var _L = {"1":[10,30],"2":[10,30],"3":[10,30],"4":[10,30]};   /* 2-6 wks, EVERY zone, ONE lane (owner 2026-11-01) */
      for (var z in _L) if (Object.prototype.hasOwnProperty.call(_L, z)) ZONE_QS_ETA[z] = _L[z];
      var _C = {"1":[10,30],"2":[10,30],"3":[10,30],"4":[10,30]};   /* 2-6 wks, EVERY zone, ONE lane (owner 2026-11-01) */
      for (var c in _C) if (Object.prototype.hasOwnProperty.call(_C, c)) ZONE_ETA[c] = _C[c];
    } catch (e) {}
  })();
  // Zones opened for Loose Truck in the 2026-08-12 contiguous expansion (used for copy that must
  // say "Residential Delivery, 6-8 weeks" rather than the West's "Loose Truck, 2-4 weeks").
  // ⛔ EMPTY since 2026-10-21: this flagged far zones as "extended lead time", which now
  //    contradicts the flat published window. Do not repopulate without changing ZONE_ETA too.
  var QS_NEW_ZONES = {};
  function bbIsNewZone(z){ return !!QS_NEW_ZONES[z]; }
  // Cart-content crane test. The estimator renders the CART's delivered price in every
  // context (renderAll uses cart.total_price), so crane must be read from actual cart
  // items — NOT the PDP variant selectors, which don't exist in the slide-cart, where
  // bbIsUnframedNow() returned false and wrongly defaulted every cart to crane.
  // Loose-light = unframed wire / loose sheets; ANY non-loose-light line
  // (framed / gate / ZM / kit / post / assembled) => crane (mixed cart => crane).
  // Positive-signal only, so a pure-unframed cart correctly reads loose.
  function bbCartHasCrane(items){
    if(!items||!items.length) return false;
    var looseLight=/unframed|just the (metal|wire)|loose sheets?|no frame/i;
    var craneSig=/ready to install|pressure treated|\bcedar\b|full metal|\bgate|zero[\s-]?maintenance|\bzm\b|\bkit\b|assembled|\bpost|corten/i;
    for(var i=0;i<items.length;i++){
      var it=items[i]||{}, t=(it.variant_title||'')+' | '+(it.title||'')+' | '+(it.product_title||'')+' | '+(it.handle||'');
      var ov=it.options_with_values; if(ov&&ov.length){for(var k=0;k<ov.length;k++){t+=' | '+((ov[k]&&ov[k].value)||'');}}
      if(looseLight.test(t)) continue;   // clearly loose-light -> not crane
      if(craneSig.test(t)) return true;  // positive crane signal -> crane
    }
    return false;
  }
  // Which LANES the cart spans. bbCartHasCrane() answered a yes/no question and so could never
  // describe the cart that costs the most: one that spans both. Same positive-signal matching as
  // before (an item matching neither pattern votes for nothing), so a pure-unframed cart still
  // reads loose and nothing that used to be crane stops being crane.
  function bbCartLanes(items){
    /* ⭐ TRUTH FIRST. cart-items.liquid publishes this from the custom.shipping_mode metafield —
       the same field profile membership (and therefore the bill) is derived from. The title
       regex below is a FALLBACK for pages where that snippet has not rendered; it misses any
       heavy item whose name lacks a crane keyword, which quoted a mixed cart as pure Light. */
    try {
      var _truth = window.__bbCartLanesTruth;
      if (_truth && typeof _truth.loose === 'boolean' && typeof _truth.crane === 'boolean') {
        return { loose: _truth.loose, crane: _truth.crane };
      }
    } catch (_e) {}
    var lanes = { loose:false, crane:false };
    if(!items||!items.length) return lanes;
    var looseLight=/unframed|just the (metal|wire)|loose sheets?|no frame/i;
    var craneSig=/ready to install|pressure treated|\bcedar\b|full metal|\bgate|zero[\s-]?maintenance|\bzm\b|\bkit\b|assembled|\bpost|corten/i;
    for(var i=0;i<items.length;i++){
      var it=items[i]||{}, t=(it.variant_title||'')+' | '+(it.title||'')+' | '+(it.product_title||'')+' | '+(it.handle||'');
      var ov=it.options_with_values; if(ov&&ov.length){for(var k=0;k<ov.length;k++){t+=' | '+((ov[k]&&ov[k].value)||'');}}
      if(looseLight.test(t)){ lanes.loose=true; continue; }
      if(craneSig.test(t)){ lanes.crane=true; }
    }
    return lanes;
  }
  /* ⭐ CART LINE ETA — fills the empty [data-bb-lane] spans that cart-items.liquid renders.
     Uses getShipDates with the lane forced, so a cart line can never show a date the card
     disagrees with. The write is skipped when the text already matches, so the observer below
     cannot retrigger itself. */
  /* ⭐ MIXED NOTICE — fills rate / ETA / saving from the SAME tables everything else reads.
     Empty, never guessed, when the zone is unknown. */
  function bbFillMixNote(){
    try{
      var _r = document.querySelector('[data-bb-mixnote]'); if(!_r) return;
      var _st = null; try { _st = sessionStorage.getItem('bb_geo_state'); } catch(e){}
      var _z = (window.BB_ZONES||{})[_st];
      var _L = (window.BB_SHIP_RATES||{})[_z], _H = (window.BB_CRANE_RATES||{})[_z];
      /* ⭐ UNKNOWN ZONE — DERIVE, NEVER GUESS. A visitor whose region does not resolve (measured:
         bb_geo_state = "UT" on the CA store, which has no such key in BB_ZONES) used to leave every
         figure blank, printing "you save at least ," at the customer. If EVERY zone in the map
         carries an identical ladder then the rate does not depend on the zone at all, so quoting
         it is a fact rather than an assumption. If any zone differs, this yields null and the
         clause below is hidden instead — self-disabling, with no constant to keep in sync. */
      if(!_L || !_H || !_L.length || !_H.length){
        var _consensus = function(map){
          try{
            var ks = Object.keys(map || {});
            if(!ks.length) return null;
            var first = JSON.stringify(map[ks[0]]);
            for(var i=1;i<ks.length;i++) if(JSON.stringify(map[ks[i]]) !== first) return null;
            return map[ks[0]];
          }catch(e){ return null; }
        };
        _L = _consensus(window.BB_SHIP_RATES);
        _H = _consensus(window.BB_CRANE_RATES);
      }
      /* ⛔ A FAILURE MUST NOT READ LIKE A SENTENCE WITH A HOLE IN IT. The two-truck warning is true
         whatever the geo, so the box stays — but the saving clause is removed when there is no
         figure to put in it, rather than rendering a dangling comma. */
      var _clause = _r.querySelector('[data-bb-mix="saveclause"]');
      if(!_L || !_H || !_L.length || !_H.length){
        if(_clause) _clause.style.display = 'none';
        return;
      }
      if(_clause) _clause.style.display = '';
      /* ⭐ THE BAND THAT MATCHES THIS LANE'S OWN SUBTOTAL, not the first band. _L[0].rate always
         printed the full rate, so the notice said $149/$199 on every cart — including a $6,000
         order that checkout delivers free. Values come from __bbCartLaneValues (cents). */
      var _lv = ((window.__bbCartLaneValues||{}).light)|0, _hv = ((window.__bbCartLaneValues||{}).heavy)|0;
      var _pick = function(tiers, cents){
        var r = tiers[0].rate;
        for (var i = 0; i < tiers.length; i++) if (cents >= tiers[i].min) r = tiers[i].rate;
        return r;
      };
      var _lr = _pick(_L, _lv), _hr = _pick(_H, _hv);
      var _set = function(k, val){
        var e = _r.querySelector('[data-bb-mix="' + k + '"]');
        if (e && val && e.textContent !== val) e.textContent = val;
      };
      _set('light-rate', money(_lr));
      _set('heavy-rate', money(_hr));
      _set('save', money(Math.min(_lr, _hr)));
      /* ⛔⛔ NO ZONE MEANS NO DATES — BUT THE RATES STILL STAND. getShipDates() with no zone
         returns ONE generic window, so both lanes printed the same span (measured: "Dec 7 – Dec
         28" for Light AND Heavy) directly above "Light is the quicker of the two". The rate is
         zone-independent and consensus-checked above, so it survives; the date is not, so it goes.
         ⛔ CLEARED, not just skipped: _set ignores empty values, so dates from an earlier render
            with a good zone would otherwise linger after a geo change and read as current. */
      var _etaZoneKnown = !!((window.BB_SHIP_RATES || {})[_z]);
      if (_etaZoneKnown) {
        try { var _dl = getShipDates(null,'q'); _set('light-eta', (_dl && (_dl.range || _dl.arrive)) || ''); } catch(e){}
        try { var _dh = getShipDates(null,'c'); _set('heavy-eta', (_dh && (_dh.range || _dh.arrive)) || ''); } catch(e){}
      } else {
        try {
          var _etaEls = _r.querySelectorAll('[data-bb-mix="light-eta"],[data-bb-mix="heavy-eta"]');
          for (var _etaI = 0; _etaI < _etaEls.length; _etaI++) _etaEls[_etaI].textContent = '';
        } catch(e){}
      }
    }catch(e){}
  }
  try{
    bbFillMixNote();
    document.addEventListener('DOMContentLoaded', bbFillMixNote);
    /* ⛔⛔ THE 150ms DEBOUNCE BELOW USED TO NEVER FIRE. Measured on the live cart page: 46 mutation
       records in 3s, and an identical debounce on this same observer fired 0 times in 6 seconds.
       Every mutation cancelled the pending call, so this function only ever ran at the two call
       sites above — both of which happen BEFORE the geo lookup resolves, where it takes its
       early return. The note sat blank with no error to find, because the catch is empty.
       ⭐ The real fix is the event subscriptions: bb:geo-change is the exact moment the zone
          arrives and the early return stops applying. */
    var _mixFill = function(){ try{ bbFillMixNote(); }catch(e){} };
    var _mixEv = ['bb:geo-change','bb:cart-lanes','bb:so-state','bb:calc-quote','bb:cart-updated'];
    for (var _mi = 0; _mi < _mixEv.length; _mi++) document.addEventListener(_mixEv[_mi], _mixFill);
    /* ⭐ bounded ladder for a geo resolution that lands without dispatching anything we hear;
       it stops as soon as the note carries a figure, so it cannot poll forever. */
    var _mixTries = [400, 1200, 2500, 5000];
    for (var _mt = 0; _mt < _mixTries.length; _mt++) {
      setTimeout(function(){
        try {
          var _n = document.querySelector('[data-bb-mixnote] [data-bb-mix="light-rate"]');
          if (_n && _n.textContent) return;    /* already filled — nothing to do */
        } catch(e){}
        _mixFill();
      }, _mixTries[_mt]);
    }
    /* ⭐ MAX WAIT: the debounce still coalesces bursts, but can no longer be starved — once a
       mutation is pending it fires within 600ms whatever else the page is doing. */
    var _mixFirst = 0;
    var _bbMixObs = new MutationObserver(function(){
      var _now = Date.now();
      if (!_mixFirst) _mixFirst = _now;
      if (_now - _mixFirst >= 600) { clearTimeout(window.__bbMixT); _mixFirst = 0; _mixFill(); return; }
      clearTimeout(window.__bbMixT);
      window.__bbMixT = setTimeout(function(){ _mixFirst = 0; _mixFill(); }, 150);
    });
    _bbMixObs.observe(document.documentElement, { childList:true, subtree:true });
  }catch(e){}
  /* ⛔⛔ THE LANE STATE MUST SURVIVE AN AJAX CART RE-RENDER — THIS WAS A LIVE MISPRICING.
     cart-items.liquid publishes __bbCartLanesTruth from an INLINE <script>, and a <script> swapped
     in with the re-rendered cart markup NEVER EXECUTES. The object froze at the composition the
     page was PARSED with, and bbCartLanes() below short-circuits to it and discards the cart it
     just fetched — so the delivery row priced a pure-Heavy cart as Mixed ($348 for $199 of
     freight), the ETA kept the mixed span, and the announcement bar never heard 'bb:cart-lanes'
     because that same dead script is what dispatches it.
     ⭐ The CHIPS are markup, so they are fresh after every re-render. data-bb-lane-mode carries the
        snippet's own bb_lane, computed from the custom.shipping_mode METAFIELD — so this is a
        re-read of the existing truth, never a second classification. */
  function bbLanesFromCartDom(){
    try{
      var els = document.querySelectorAll('[data-bb-lane-mode]');
      if(!els.length) return null;          /* no cart markup here — never clobber the inline value */
      var loose=false, crane=false;
      for(var i=0;i<els.length;i++){
        var m = els[i].getAttribute('data-bb-lane-mode');
        if(m === 'c') crane = true;
        else if(m === 'q') loose = true;    /* '' = ships free: rides along, votes for NEITHER lane */
      }
      return { loose: loose, crane: crane };
    }catch(e){ return null; }
  }
  function bbRepublishLanes(){
    try{
      var d = bbLanesFromCartDom();
      if(!d) return;
      var t = window.__bbCartLanesTruth;
      /* ⛔ republish only on a REAL change: the banner's refresh() mutates the DOM, which re-fires
         the observer that called this, which would otherwise loop forever. */
      if(t && t.loose === d.loose && t.crane === d.crane) return;
      window.__bbCartLanesTruth = d;
      window.__bbCartLanes = d;
      try{ document.dispatchEvent(new CustomEvent('bb:cart-lanes')); }catch(e){}
      /* ⛔⛔ THE EVENT ALONE ONLY MOVES THE ANNOUNCEMENT BAR — it is the one listener. The delivery
         card on the PDP and in the drawer is painted by renderAll(), and this file subscribes to
         bb:so-state, bb:calc-quote and bb:geo-change but NEVER to a lane change. Without this the
         lane is correct in window and stale on screen, and only a hard refresh fixes it (owner
         2026-10-17: "pdp doesn't update on any of this logic without a hard refresh").
         ⭐ bbReeval() re-reads /cart.js and re-renders every surface this file owns; it is already
         debounced. ⛔ The re-render re-fires the observer that called us — harmless ONLY because
         the guard above returns early once the derived lanes match. Do not remove that guard. */
      try{ bbReeval(); }catch(e){}
    }catch(e){}
  }
  function bbFillLaneEtas(){
    try{
      var _n = document.querySelectorAll('span[data-bb-lane]');
      if(!_n.length) return;
      var _c = {};
      for(var _i=0;_i<_n.length;_i++){
        var _ln = _n[_i].getAttribute('data-bb-lane');
        if(!(_ln in _c)){
          try{ var _d = getShipDates(null, _ln); _c[_ln] = (_d && (_d.range || _d.arrive)) ? (_d.range || _d.arrive) : ''; }
          catch(e){ _c[_ln] = ''; }
        }
        if(_c[_ln] && _n[_i].textContent !== _c[_ln]) _n[_i].textContent = _c[_ln];
      }
    }catch(e){}
  }
  try{
    bbFillLaneEtas();
    document.addEventListener('DOMContentLoaded', bbFillLaneEtas);
    var _bbLaneObs = new MutationObserver(function(){
      clearTimeout(window.__bbLaneT);
      /* ⭐ lanes FIRST, then the dates that depend on them — same observer, same 120ms debounce */
      window.__bbLaneT = setTimeout(function(){ bbRepublishLanes(); bbFillLaneEtas(); }, 120);
    });
    _bbLaneObs.observe(document.documentElement, { childList:true, subtree:true });
  }catch(e){}
  function bbCartMixedNow(){ try {
    return !!(window.__bbCartLanes && window.__bbCartLanes.loose && window.__bbCartLanes.crane);
  } catch(e){ return false; } }
  // MIXED ladder = quick + crane, band by band. Both profiles read the WHOLE cart total, so the
  // bands line up and the sum is exact rather than an estimate. Built only for zones the crane
  // truck actually reaches — everywhere else a mixed cart has no checkout rate at all and must
  // not be handed a number (see the bb:ship-rate dispatch below).
  var _bbMixedCache = null;
  function bbMixedRates(){
    if(_bbMixedCache) return _bbMixedCache;
    var out = {};
    for(var z in CRANE_RATES){
      if(!CRANE_RATES.hasOwnProperty(z) || !RATES[z]) continue;
      out[z] = CRANE_RATES[z].map(function(t, i){
        /* ⭐ TWO PROFILES AGAIN 2026-10-16 — Shopify bills one rate per profile a cart touches, so a
           mixed cart really is charged both lanes. Restored to the sum this function was built for. */
        /* ⛔ NO LONGER A SUM (2026-11-01). Light and Heavy are ONE profile now, so a cart cannot
           touch two profiles and cannot be billed twice. Summing printed $198 against a $99
           checkout. Kept as a function because three surfaces call it. */
        return { min: t.min, rate: t.rate, label: t.rate === 0 ? 'FREE' : '$' + (t.rate / 100) };
      });
    }
    _bbMixedCache = out;
    return out;
  }
  function bbCraneNow(){ try {
    // Cart with items -> truth from cart contents; empty cart -> PDP selection fallback.
    /* ⭐ ONE OWNER for the lane signal. Publish whatever this returns so the
       announcement bar cannot disagree with the PDP: the bar used to read a
       cart-only flag and showed "from $49" under a $99 crane variant. */
    /* ⛔ OFF-PDP THE LANE IS LOOSE. bbIsUnframedNow() returns false when bbHogWire is unset,
       and bbHogWire only ever comes from #bb-ship-est-product (a PDP-only element). So on the
       homepage/collections/blog the old `!bbIsUnframedNow()` evaluated to TRUE and the bar
       quoted the CRANE entry ($199) where the honest "from" price is loose ($149).
       On a PDP the viewed-variant fallback is kept exactly as it was. */
    var _bbOnPdp = !!document.getElementById('bb-ship-est-product');
    /* ⭐ shipping_mode is the field the PROFILE bills on, so it outranks the framing guess:
       "loose - heavy" is unframed yet bills CRANE. Returns null when the attribute is absent,
       so older pages fall through to the previous behaviour unchanged. */
    var _bbModeLane = (function(){
      try {
        var _el = document.getElementById('bb-ship-est-product');
        if (!_el) return null;
        var _ids = _el.getAttribute('data-bb-crane-ids');
        if (_ids === null) return null;
        var _f = document.querySelector('form[action*="/cart/add"] [name="id"]');
        var _id = _f && _f.value;
        if (!_id) return null;
        return (' ' + _ids + ' ').indexOf(' ' + _id + ' ') !== -1;
      } catch (e) { return null; }
    })();
    /* ⭐⭐ THE CART TRUTH OUTRANKS EVERYTHING ELSE. __bbCartCrane* is a SECOND, older cart-lane
       flag and is NOT the one cart-items.liquid publishes, so a pure-Heavy cart could leave
       __bbLaneCrane FALSE — and the delivery row printed "Light Delivery · $149" over a crane-only
       cart while the DATE beside it correctly read the Heavy window (measured live 2026-10-17).
       __bbCartLanesTruth comes from custom.shipping_mode, the field the PROFILE bills on, and is
       refreshed on every cart re-render, so it is the authority whenever the cart holds a lane.
       ⛔ The POLICY is unchanged — the old chain already preferred the cart when it had items and
          fell back to the viewed variant only for an EMPTY cart. Only the source is corrected.
       ⛔ A MIXED cart never reaches here: bbRates() returns the summed ladder from bbCartMixedNow()
          first. */
    var _bbTruth = window.__bbCartLanesTruth;
    var _bbTruthLane = (_bbTruth && (_bbTruth.crane || _bbTruth.loose)) ? !!_bbTruth.crane : null;
    var _bbLane = (_bbTruthLane !== null)
      ? _bbTruthLane
      : ((window.__bbCartCraneKnown && window.__bbCartItemCount>0)
        ? !!window.__bbCartCrane
        : (_bbModeLane !== null ? _bbModeLane
          : (_bbOnPdp ? !bbIsUnframedNow() : false)));
    try { window.__bbLaneCrane = _bbLane; } catch(e){}
    return _bbLane;
  } catch(e){ return false; } }
  // The VIEWED variant counts, not just the cart: a shopper looking at a framed panel with an
  // empty cart is a crane order, and quoting the Loose Truck ladder under-quotes them by $100.
  // Only #bb-ship-est-product exists on a PDP, so cart contexts are unaffected.
  function bbPdpCraneNow(){
    try {
      if (!document.getElementById('bb-ship-est-product')) return false;
      return bbHogWire ? !bbIsUnframedNow() : true;
    } catch (e) { return false; }
  }
  // A mixed cart is charged BOTH profiles, so it must be quoted from both. Verified live:
  // $549.98 mixed cart -> checkout "Shipping = 198.00", not the $149 this used to render.
  function bbRates(){
    if (bbCartMixedNow()) return bbMixedRates();
    if (bbCartMixedNow()) { var _mx = bbMixedRates(); if (_mx && Object.keys(_mx).length) return _mx; }
    return bbCraneNow() ? CRANE_RATES : RATES;   // cart truth only — bbPdpCraneNow() is bbCraneNow()'s own empty-cart fallback, and OR-ing it quoted CRANE for a known LOOSE cart viewed from a crane PDP
  }

  try { window.BB_SHIP_RATES = RATES; window.BB_CRANE_RATES = CRANE_RATES; window.BB_ZONES = ZONES; window.BB_ZONE_ETA = ZONE_ETA; /* ⛔ removed: re-published the EMPTY CRANE_PAUSED_STATES over the real set */ window.BB_RESUME_INFO = RESUME_INFO;
    /* Loose Truck contiguous expansion 2026-08-12 — consumers (banner, PDP, FOB) need to tell
       "crane can't reach you" apart from "we don't serve you at all". */
    window.BB_CRANE_SERVED = CRANE_SERVED; window.BB_QS_NEW_ZONES = QS_NEW_ZONES;
    /* The header bar needs the SUM for a cart that spans both profiles. Exported as a function so
       there is exactly one implementation of "what does a mixed cart cost" on the page. */
    window.BB_MIXED_RATES_FN = bbMixedRates;
    window.BB_ZONE_QS_ETA = ZONE_QS_ETA; /* ⭐ ONE owner for the holiday table — the PDP accordion reads it instead of carrying a 5th copy. */ window.BB_HOL = _BB_HOL; window.BB_UNSERVED_STATES = UNSERVED_STATES;
    window.BB_CRANE_PAUSED_STATES = CRANE_PAUSED_STATES; } catch (e) {}

  var STATE_NAMES = {
    'AL':'Alabama','AK':'Alaska','AZ':'Arizona','AR':'Arkansas','CA':'California',
    'CO':'Colorado','CT':'Connecticut','DE':'Delaware','DC':'Washington DC','FL':'Florida',
    'GA':'Georgia','HI':'Hawaii','ID':'Idaho','IL':'Illinois','IN':'Indiana',
    'IA':'Iowa','KS':'Kansas','KY':'Kentucky','LA':'Louisiana','ME':'Maine',
    'MD':'Maryland','MA':'Massachusetts','MI':'Michigan','MN':'Minnesota','MS':'Mississippi',
    'MO':'Missouri','MT':'Montana','NE':'Nebraska','NV':'Nevada','NH':'New Hampshire',
    'NJ':'New Jersey','NM':'New Mexico','NY':'New York','NC':'North Carolina','ND':'North Dakota',
    'OH':'Ohio','OK':'Oklahoma','OR':'Oregon','PA':'Pennsylvania','RI':'Rhode Island',
    'SC':'South Carolina','SD':'South Dakota','TN':'Tennessee','TX':'Texas','UT':'Utah',
    'VT':'Vermont','VA':'Virginia','WA':'Washington','WV':'West Virginia','WI':'Wisconsin','WY':'Wyoming'
  };

  // US zip code prefix → state mapping (first 3 digits)
  /* ⛔ The 904-prefix ZIP_TO_STATE table that used to sit here now lives in
     assets/bb-geo.js and is reached through window.BBGeo. It was duplicated
     into bb-freight-finder.js and approximated a THIRD time in
     bb-dynamic-banner.js, where prefix 246 resolved to VA instead of WV and
     quoted a different zone. One table, loaded once, is the whole point. */

  var geoState = null;
  var geoCity = null;
  var geoZone = null;
  var lastTierIndex = -1;

  function resetGeo() {
    geoState = null;
    geoCity = null;
    geoZone = null;
    lastTierIndex = -1;
    sessionStorage.removeItem('bb_geo_state');
    sessionStorage.removeItem('bb_geo_city');
    // Hide estimator widgets
    var est;
    est = document.getElementById('bb-ship-est-product');
    if (est) { est.style.display = 'none'; est.removeAttribute('data-rendered'); est.removeAttribute('data-ga4-viewed'); }
    est = document.getElementById('bb-ship-est-cart');
    if (est) { est.style.display = 'none'; est.removeAttribute('data-rendered'); est.removeAttribute('data-ga4-viewed'); }
    // Show zip forms
    showZipFallback();
  }

  // === GA4 EVENT HELPER (no Plus required) ===
  function ga4Event(name, params) {
    if (typeof gtag === 'function') {
      gtag('event', name, params || {});
    }
  }

  function money(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('en-US');
  }

  // BarrierBucks earn line — appended to the trust strip, renders ONLY when
  // window.BB_BUCKS.enabled (set by bb-discount-config.liquid from
  // shop.metafields.bb_loyalty.config; defaults disabled = zero change).
  // "Up to": the engine awards on the POST-discount subtotal, so this is a ceiling.
  function bbBucksLine(cartTotal) {
    var B = window.BB_BUCKS;
    if (!B || !B.enabled) return ''; // re-enabled 2026-07-03: BarrierBucks lives in the estimator, not the strip — estimator line disabled (re-enable by restoring the B.enabled gate)
    var rate = (typeof B.rate === 'number' && B.rate > 0 && B.rate < 1) ? B.rate : 0.03;
    var cap = (typeof B.cap === 'number' && B.cap > 0) ? B.cap : 500;
    var url = B.url || '/pages/barrierbucks';
    var _bbT = Math.max(0, cartTotal - (window.__bbSampleCents || 0)); /* samples are fully credited — no bucks */
  var amt = (_bbT > 0) ? Math.min(cap, Math.floor((_bbT / 100) * rate)) : 0;
    var msg = (amt >= 1)
      ? 'Earn up to <strong style="color:#EB673C;">$' + amt + ' in BarrierBucks</strong> on this order'
      : 'Earn <strong style="color:#EB673C;">' + Math.round(rate * 100) + '% back in BarrierBucks</strong> on every order';
    return '<div class="bb-bucks-line" style="padding:7px 14px;border-top:1px solid rgba(0,0,0,.06);text-align:center;font-size:11px;line-height:1.4;color:#1a1a1a;">💵 ' + msg + ' — store credit for your next order. <a href="' + url + '" style="color:#EB673C;text-decoration:underline;font-weight:600;">How it works</a></div>';
  }

  /* ⭐ The Reviews tab's body. Reads window.BB_DRS, published by bb-delivery-rating-badge.liquid —
     Liquid owns the metafield, this owns the slot. Rebuilt with the rest of the panel on every
     render, so there is nothing to re-attach and nothing to wipe.
     ⛔ Fails to an empty string, never throws: this string is concatenated into the card, and a
     throw here would take the whole estimator down. */
  function _bbDrsPanel(){
    /* ⭐ REVIEW CAROUSEL 2026-11-01. One review at a time with arrows either side, replacing the
       vertical scroll list. The nav handler lives on window because this function returns a
       STRING that is rebuilt on every render — anything bound with addEventListener would be
       wiped on the next repaint, and an inline expression carrying a selector needs three levels
       of quote escaping. */
    try {
      var D = window.BB_DRS;
      if (!D || !D.r || !D.r.length) return '<span class="bb-pt-body bb-pt-body--them"></span>';
      if (!window.__bbDrsNav) {
        /* DRS HEIGHT FIT 2026-11-01: the track is a flex row, so without this it stands as tall as the
           LONGEST review and a short quote leaves dead space under it. */
        window.__bbDrsFit = function(t){
          try {
            if (!t || !t.children.length) return;
            var w = t.clientWidth || 1, i = Math.round(t.scrollLeft / w);
            var el = t.children[Math.max(0, Math.min(t.children.length - 1, i))];
            if (el && el.offsetHeight) t.style.height = el.offsetHeight + 'px';
          } catch (e) {}
        };
        window.__bbDrsNav = function(btn, dir){
          try {
            var t = btn.parentNode && btn.parentNode.querySelector('.bb-drs-track');
            if (!t) return;
            t.scrollBy({ left: dir * (t.clientWidth || 220), behavior: 'smooth' });
            setTimeout(function(){ window.__bbDrsFit(t); }, 240);
          } catch (e) {}
        };
        /* scroll does NOT bubble — this must be a capture-phase listener to see track scrolls */
        try { document.addEventListener('scroll', function(e){
          var t = e.target;
          if (t && t.classList && t.classList.contains('bb-drs-track')) window.__bbDrsFit(t);
        }, true); } catch (e) {}
        /* a freshly rendered track has no height and nobody has scrolled it yet. Bounded poll. */
        try { var _n = 0, _iv = setInterval(function(){
          _n++;
          var ts = document.querySelectorAll('.bb-drs-track');
          for (var i = 0; i < ts.length; i++) if (!ts[i].style.height) window.__bbDrsFit(ts[i]);
          if (_n > 20) clearInterval(_iv);
        }, 500); } catch (e) {}
      }
      var esc = function(t){ return String(t == null ? '' : t).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); };
      var out = '';
      for (var i = 0; i < D.r.length; i++) {
        var q = D.r[i] || {}, who = (q.n || '') + (q.c ? ', ' + q.c : '');
        out += '<span class="bb-drs-slide">\u201c' + esc(q.t) + '\u201d'
            + (who ? '<span class="bb-drs-w">\u2014 ' + esc(who) + '</span>' : '')
            + '</span>';
      }
      var nav = D.r.length > 1;
      return '<span class="bb-pt-body bb-pt-body--them" style="text-align:center">'
        + '<strong style="display:block;margin-bottom:5px;font-size:12.5px;line-height:1.35">'
        + '<span style="color:#EB673C;letter-spacing:1px">\u2605\u2605\u2605\u2605\u2605</span> '
        + esc(D.a) + ' \u00b7 ' + esc(D.c) + '+ delivery reviews</strong>'
        + '<span class="bb-drs-wrap">'
        + (nav ? '<button type="button" class="bb-drs-nav" aria-label="Previous review" onclick="window.__bbDrsNav(this,-1)">\u2039</button>' : '')
        + '<span class="bb-drs-track">' + out + '</span>'
        + (nav ? '<button type="button" class="bb-drs-nav" aria-label="Next review" onclick="window.__bbDrsNav(this,1)">\u203a</button>' : '')
        + '</span>'
        + '</span>';
    } catch (e) { return '<span class="bb-pt-body bb-pt-body--them"></span>'; }
  }
  function getShipDates(zone, forceLane) {
    /* ZONE-AWARE (owner 2026-07-27): [craneLo,craneHi,quickLo,quickHi] days by shopper state. FLAT everywhere: Quick 2-4wk (14-28d) / Crane 6-8wk (42-56d). Zone spread retired 2026-07-31. */
    // ⭐⭐ 2026-08-12: lead time is NO LONGER FLAT. The old `_LT` gave every destination
    // [crane 42-56, quick 14-28], which after the contiguous expansion would promise FLORIDA
    // 2-4 weeks — a date we cannot hit on a ~3,350 mi haul. Zone ETA now drives the dates:
    // Loose Truck  West 2-4 wk · Plains 3-5 · Midwest & Mid-South 4-6 · Atlantic & Deep South 6-8.
    // West keeps exactly its old numbers, so nothing changes for existing customers.
    /* ⛔ BUSINESS DAYS, NOT CALENDAR — checkout counts processingTime (P10D = 10 business
     days) + transit in business days. Adding calendar days made this promise EARLIER than
     checkout in every zone. Weekends skipped; holidays are not modelled, which errs LATE
     (safe) rather than early. */
  /* ⛔ HOLIDAYS SKIPPED TO MATCH CHECKOUT, NOT BECAUSE WE STOP (owner 2026-10-17: "it's not
     like our trucks stop on holidays they're out on the road"). Shopify's checkout date DOES skip
     them and the customer sees both numbers in one session. Measured on a Maryland cart:
     storefront Dec 11-25 vs checkout Dec 17-Jan 4, which reconciles to exactly +1 business day
     once these days come out. Matching them closes the visible gap and errs LATE.
     ⛔⛔ DO NOT re-base transit to calendar days to "be honest about 7-day trucking". The card is
     business days end to end: "2-4 weeks" IS 10-20 business days and the LOW bound is processing
     alone, which is why processing can never exceed 10bd. A 7-day transit basis breaks every
     published label (Light Z1 2-4 -> 2-3.4 wks). */
  var _BB_HOL = {"2026-01-01":1,"2026-01-19":1,"2026-02-16":1,"2026-05-25":1,"2026-06-19":1,"2026-07-03":1,"2026-09-07":1,"2026-10-12":1,"2026-11-11":1,"2026-11-26":1,"2026-11-27":1,"2026-12-25":1,"2027-01-01":1,"2027-01-18":1,"2027-02-15":1,"2027-05-31":1,"2027-06-18":1,"2027-07-05":1,"2027-09-06":1,"2027-10-11":1,"2027-11-11":1,"2027-11-25":1,"2027-11-26":1,"2027-12-24":1,"2027-12-31":1,"2028-01-17":1,"2028-02-21":1,"2028-05-29":1,"2028-06-19":1,"2028-07-04":1,"2028-09-04":1,"2028-10-09":1,"2028-11-10":1,"2028-11-23":1,"2028-11-24":1,"2028-12-25":1,"2029-01-01":1,"2029-01-15":1,"2029-02-19":1,"2029-05-28":1,"2029-06-19":1,"2029-07-04":1,"2029-09-03":1,"2029-10-08":1,"2029-11-12":1,"2029-11-22":1,"2029-11-23":1,"2029-12-25":1,"2030-01-01":1,"2030-01-21":1,"2030-02-18":1,"2030-05-27":1,"2030-06-19":1,"2030-07-04":1,"2030-09-02":1,"2030-10-14":1,"2030-11-11":1,"2030-11-28":1,"2030-11-29":1,"2030-12-25":1,"2031-01-01":1,"2031-01-20":1,"2031-02-17":1,"2031-05-26":1,"2031-06-19":1,"2031-07-04":1,"2031-09-01":1,"2031-10-13":1,"2031-11-11":1,"2031-11-27":1,"2031-11-28":1,"2031-12-25":1};
  /* ⭐ re-publish AFTER assignment — the early publish above runs on a hoisted undefined */
  try { window.BB_HOL = _BB_HOL; } catch (e) {}
  function _bbAddBd(n) {
    var d = new Date(); var i = 0;
    while (i < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w === 0 || w === 6) continue;
      if (_BB_HOL[d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2)]) continue;
      i++;
    }
    return d;
  }
  var _LT = {WA:[10,30,10,30],OR:[10,30,10,30],ID:[10,30,10,30],CA:[10,30,10,30],UT:[10,30,10,30],WY:[10,30,10,30],CO:[10,30,10,30],MT:[10,30,10,30],AZ:[10,30,10,30],NV:[10,30,10,30],NM:[10,30,10,30],TX:[10,30,10,30],OK:[10,30,10,30]};
    /* ⭐⭐ THE CART DECIDES THE DATE WHENEVER IT HOLDS ONE LANE. This read the VIEWED PDP
       VARIANT's framing, and the slide-cart has no variant selectors — so on an Unframed PDP a
       crane-only cart was dated on the LIGHT window while the rate row beside it correctly said
       "Heavy · $199" (measured live 2026-10-17). Same authority as the rate now uses:
       custom.shipping_mode, via __bbCartLanesTruth, refreshed on every cart re-render.
       ⛔ forceLane still wins — the per-lane calls that build the two-truck breakdown must answer
          for their own lane.
       ⛔ A MIXED cart resolves to null on purpose: the span branch below owns it (light low ->
          heavy high) and setting _q here would flatten it to a single lane.
       ⛔ An EMPTY cart still falls back to the viewed variant — a shopper eyeing a framed panel
          with an empty cart is a crane order. */
    var _bbCt = window.__bbCartLanesTruth;
    var _bbCtLane = (_bbCt && (_bbCt.crane || _bbCt.loose) && !(_bbCt.crane && _bbCt.loose))
      ? !_bbCt.crane : null;
    var _q = (forceLane === 'q') ? true : (forceLane === 'c') ? false
      : (_bbCtLane !== null ? _bbCtLane : (bbHogWire && bbIsUnframedNow())), _z = _LT[geoState] || [10,30,10,30];
    var lo = _q ? _z[2] : _z[0], hi = _q ? _z[3] : _z[1];
    // zone-aware override for the newly opened territory (zones 3/4/7)
    var _zn = ZONES[geoState];
    if (_zn && bbIsNewZone(_zn)) {
      var _qe = ZONE_QS_ETA[_zn], _ce = ZONE_ETA[_zn];
      if (_q && _qe) { lo = _qe[0]; hi = _qe[1]; }
      else if (_ce)  { lo = _ce[0]; hi = _ce[1]; }
    }

    /* ⭐ MIXED CART = TWO DELIVERIES, ONE TRUE RANGE (owner 2026-10-17: "taking the earliest and
       latest date and spanning it — that gives them the full date range within which their orders
       will arrive"). _z is [craneLo,craneHi,quickLo,quickHi], so the light low is _z[2] and the
       heavy high is _z[1]. ⛔ Only when no lane is forced — the per-lane calls that build the
       mixed-cart breakdown must keep answering for their own lane. */
    if (!forceLane && window.__bbCartLanes && window.__bbCartLanes.loose && window.__bbCartLanes.crane) {
      var _mLo = _z[2], _mHi = _z[1];
      if (_zn && bbIsNewZone(_zn)) {
        var _mq = ZONE_QS_ETA[_zn], _mc = ZONE_ETA[_zn];
        if (_mq) _mLo = _mq[0];
        if (_mc) _mHi = _mc[1];
      }
      lo = _mLo; hi = _mHi;
    }
    if (bbSO) { lo = 40; hi = 60; }
    var d1 = _bbAddBd(lo);
    var d2 = _bbAddBd(hi);
    var m = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var earliest = m[d1.getMonth()] + ' ' + d1.getDate();
    var latest = m[d2.getMonth()] + ' ' + d2.getDate();
    // arrive = the displayed range string (existing render uses dates.arrive)
    return { ship: earliest, arrive: earliest + ' \u2013 ' + latest, earliest: earliest, latest: latest, so: bbSO };
  }

  function getCurrentTierIndex(zone, total) {
    var tiers = bbRates()[zone];
    for (var i = tiers.length - 1; i >= 0; i--) {
      if (total >= tiers[i].min) return i;
    }
    return -1;
  }

  var avgItemPrice = 0;

  function panelHint(gap) {
    if (!avgItemPrice || avgItemPrice <= 0) return '';
    var count = Math.ceil(gap / avgItemPrice);
    if (count <= 0) return '';
    var word = count === 1 ? 'panel' : 'panels';
    return ' <span style="color:#888;font-weight:400">(\u2248' + count + ' more ' + word + ')</span>';
  }

  function renderElement(ctx, cartTotal) {
    var el = document.getElementById('bb-ship-est-' + ctx);
    if (!el || !geoState || !geoZone) return;

    var headerEl = document.getElementById('bb-ship-header-' + ctx);
    var statusEl = document.getElementById('bb-ship-status-' + ctx);
    var tiersEl = document.getElementById('bb-ship-tiers-' + ctx);
    var deliveryEl = document.getElementById('bb-ship-delivery-' + ctx);
    var progressEl = document.getElementById('bb-ship-progress-' + ctx);
    var barEl = document.getElementById('bb-ship-bar-' + ctx);
    if (!statusEl || !tiersEl || !deliveryEl || !progressEl || !barEl) return;

    // === NO-SERVICE / CRANE-ONLY-PAUSED REGION ===
    // ⭐⭐ 2026-08-12: this used to fire for all 35 eastern states. Loose Truck now REACHES them
    // (checkout profile "Loose Truck — Contiguous" is live), so firing here would tell a buyer we
    // don't deliver while the cart happily charges them $349. It now fires ONLY when:
    //   (a) the state has no service at all (AR / AK / HI / territories), or
    //   (b) the CART NEEDS A CRANE and the crane truck can't reach that state yet.
    // In case (b) inside a Quick-Ship-served state we do NOT dead-end — we nudge to Unframed,
    // which does ship there (owner: "we need to nudge somehow to quick ship").
    var bbUnserved   = !!UNSERVED_STATES[geoState];
    // ⚠️ bbCraneNow() reads the CART on purpose (the slide-cart has no variant selectors), so it
    // is FALSE for a shopper merely LOOKING at a framed variant on the PDP. That is exactly the
    // person we must catch — owner: "if people in those locations are looking at product variants
    // that are crane we need to nudge somehow to quick ship." So consider the VIEWED variant too.
    var bbPdpEl    = document.getElementById('bb-ship-est-product');
    var bbPdpCrane = bbPdpCraneNow();   // single source of truth, shared with bbRates()
    // Does THIS product offer an Unframed alternative? Only then can we nudge to it — owner:
    // "...viewing crane versions of products WHERE LOOSE EXISTS". Gates/kits have no loose twin,
    // so they get the honest "not available yet" message instead of a nudge that goes nowhere.
    var bbHasLooseAlt = !!bbHogWire;
    var bbCraneBlocked = (bbCraneNow() || bbPdpCrane) && !!CRANE_PAUSED_STATES[geoState] && !bbUnserved;
    var bbQsReaches  = !!ZONES[geoState] && !bbUnserved;
    if (bbUnserved || bbCraneBlocked) {
      var _rnP = STATE_NAMES[geoState] || geoState;
      var pLoc = geoCity ? (geoCity + ', ' + geoState) : _rnP;
      var pInfo = RESUME_INFO[geoState] || ['Q4 2027', null];
      var pWhen = pInfo[0], pHub = pInfo[1];
      if (headerEl) {
        headerEl.innerHTML = bbCraneBlocked && bbQsReaches && bbHasLooseAlt
          ? '<span class="bb-ship-header__zone">🚚 Delivering to <span class="bb-ship-header__loc">' + pLoc + '</span> — <strong class="bb-ship-header__loc">Unframed only</strong> <a href="#" class="bb-ship-change" data-bb-reset>change</a></span>'
          : (bbCraneBlocked && bbQsReaches)
            // Crane-only PRODUCT in a Loose Truck zone — the limit is the item, not the address.
            ? '<span class="bb-ship-header__zone">🚚 Delivering to <span class="bb-ship-header__loc">' + pLoc + '</span> — <strong class="bb-ship-header__loc">Your order</strong> <a href="#" class="bb-ship-change" data-bb-reset>change</a></span>'
            // Genuinely off our routes. No resume date — the old RESUME_INFO quarters were
            // written for the pre-expansion pause and are not a commitment we can keep.
            : '<span class="bb-ship-header__zone">🚚 <span class="bb-ship-header__loc">' + pLoc + '</span> — <strong class="bb-ship-header__loc">' + (typeof PAUSED_REGIONS !== 'undefined' && PAUSED_REGIONS[geoState] ? 'new orders paused' : 'not on our routes yet') + '</strong> <a href="#" class="bb-ship-change" data-bb-reset>change</a></span>';
      }
      statusEl.style.display = ''; // notice lives in statusEl — re-show it (lean cart hides it)
      // Widened: a crane-only product (no unframed twin) in a Loose Truck zone used to fall
      // through to "we don't deliver to <state>", which is false — we do, just not this item.
      if (bbCraneBlocked && bbQsReaches) {
        // NUDGE, never a dead end: crane can't reach them, but Unframed can.
        var nzETA = ZONE_QS_ETA[ZONES[geoState]] || [28,42];
        // Owner 2026-08-12: "4-6 weeks and 6-8 weeks is sticker shock — soften it with date ranges".
        var _nzM = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        var _nzD1 = new Date(Date.now() + nzETA[0] * 86400000);
        var _nzD2 = new Date(Date.now() + nzETA[1] * 86400000);
        var nzWk  = _nzM[_nzD1.getMonth()] + ' ' + _nzD1.getDate() + ' \u2013 ' + _nzM[_nzD2.getMonth()] + ' ' + _nzD2.getDate();
        var nzR   = RATES[ZONES[geoState]];
        var nzFrom = nzR && nzR.length ? nzR[0].label : '';
        var bbCraneOnlyHere = !bbHasLooseAlt;   // no unframed twin => the ITEM is the limit
        if (bbCraneOnlyHere) {
          statusEl.innerHTML =
            '<div style="text-align:left;line-height:1.5;">' +
            '<strong>This one travels on our crane truck, which we run in WA, OR, CA, ID, MT, WY, UT, NV, AZ, NM, CO, TX &amp; OK.</strong> ' +
            'Crane truck items aren\u2019t available in ' + pLoc + ' yet \u2014 but plenty is. ' +
            '<strong>Unframed hog wire panels, cattle panel and deck railing</strong> all ship to you with ' +
            '<strong>BARRIERBOSS Residential Delivery</strong>, delivered and unloaded on your property' +
            (nzFrom ? ' \u2014 from <strong>' + nzFrom + '</strong>' : '') + ', arriving <strong>' + nzWk + '</strong>.' +
            '<div style="margin-top:8px;"><a href="/collections/hog-fencing" style="display:inline-block;font-weight:700;text-decoration:underline;color:#EB673C;">Shop what ships to ' + pLoc + ' \u2192</a></div>' +
            '</div>';
        } else {
        statusEl.innerHTML =
          '<div style="text-align:left;line-height:1.5;">' +
          '<strong>We deliver to ' + pLoc + ' — but not the assembled/framed version yet.</strong> ' +
          'Our crane truck runs in WA, OR, CA, ID, MT, WY, UT, NV, AZ, NM, CO, TX &amp; OK. ' +
          '<strong>Switch Frame Type to “Unframed”</strong> and this panel ships to you with ' +
          '<strong>BARRIERBOSS Residential Delivery</strong> — delivered and unloaded on your property' +
          (nzFrom ? ' — from <strong>' + nzFrom + '</strong>' : '') + ', arriving <strong>' + nzWk + '</strong>.' +
          '</div>';
        }
      } else {
        statusEl.innerHTML = (typeof PAUSED_REGIONS !== 'undefined' && PAUSED_REGIONS[geoState])
          ? ('<div style="text-align:center;line-height:1.55;">'
             + '<strong style="color:#bf360c">New orders to ' + _rnP + ' are paused.</strong> '
             + 'We can’t keep up with demand, so we’ve paused new orders here while we catch up. Existing orders are unaffected and ship as scheduled.'
             + (pWhen ? ('<div style="margin-top:10px;padding:10px 12px;background:#FDF1EC;border-radius:8px;"><strong>Resumes '
                 + pWhen + '</strong>' + (pHub ? ' · when our ' + pHub + ' hub opens' : '') + '</div>') : '')
             + '<div style="margin-top:10px;"><a href="/pages/new-facilities#reserve" style="font-weight:700;color:#EB673C;">Reserve a delivery window →</a></div>'
             + '</div>')
          : ('<div style="text-align:center;line-height:1.5;">'
             + '<strong>We don’t deliver to ' + pLoc + '.</strong> '
             + 'We move every panel on our own trucks and unload it on your property — we don’t hand freight to LTL carriers, '
             + 'so we’d rather say so plainly than take an order we can’t deliver properly. '
             + '<span style="color:#555;">Already ordered? Your order is unaffected and ships as scheduled.</span>'
             + '<div style="margin-top:8px;"><a href="/pages/contact" style="display:inline-block;font-weight:700;text-decoration:underline;color:#EB673C;">Tell us where you are →</a> '
             + '<span style="color:#888;font-size:11px;">We’ll let you know if that ever changes.</span></div>'
             + '</div>');
      }
      tiersEl.innerHTML = '';
      progressEl.style.display = 'none';
      deliveryEl.style.display = 'none';
      var pTrustEl = document.getElementById('bb-ship-trust-' + ctx);
      if (pTrustEl) pTrustEl.innerHTML = '';
      if (!el.dataset.ga4Viewed) {
        el.dataset.ga4Viewed = '1';
        ga4Event('bb_estimator_paused_view', { context: ctx, state: geoState, cart_total: cartTotal / 100 });
      }
      el.style.display = 'block';
      var _pzEls = document.querySelectorAll('[id="bb-ship-zip-' + ctx + '"]');
      for (var _pzi = 0; _pzi < _pzEls.length; _pzi++) _pzEls[_pzi].style.display = 'none';
      return;
    }
    // FREIGHT REBUILD 2026-07-09: no free goal to fill toward — the hero states
    // the real per-cart delivery cost. Progress bar retired (was "spend to free").
    progressEl.style.display = 'none';

    var tiers = bbRates()[geoZone];
    var currentIdx = getCurrentTierIndex(geoZone, cartTotal);
    var freeTier = tiers[tiers.length - 1];
    var atFree = cartTotal >= freeTier.min;

    // Celebration animation + GA4 event when tier changes upward
    if (currentIdx > lastTierIndex && lastTierIndex >= 0) {
      el.classList.remove('bb-ship-est--celebrating');
      void el.offsetWidth;
      el.classList.add('bb-ship-est--celebrating');
      ga4Event('bb_estimator_tier_unlock', {
        zone: geoZone, state: geoState, tier: currentIdx,
        rate_label: tiers[currentIdx].label, cart_total: cartTotal / 100
      });
    }
    lastTierIndex = currentIdx;

    var thumbEl = document.getElementById('bb-ship-thumb-' + ctx);

    // === PROGRESS BAR (spans $0 to FREE tier) ===
    var freeMin = freeTier.min;
    var progressPercent;
    if (atFree) {
      progressPercent = 100;
      progressEl.classList.add('bb-ship-progress--complete');
    } else {
      progressEl.classList.remove('bb-ship-progress--complete');
      progressPercent = Math.min(Math.max((cartTotal / freeMin) * 100, 1), 99);
    }
    barEl.style.width = progressPercent + '%';
    if (thumbEl) {
      thumbEl.style.position = 'absolute';
      thumbEl.style.left = progressPercent + '%';
    }

    // === STATUS MESSAGE ===
    // Slider/ladder removed in BOTH contexts (owner 2026-07): the dynamic hero
    // token ("Delivered FREE / for $199\u2026") shows the current rate, so the
    // status line is redundant everywhere. (Paused-region notice above still
    // uses statusEl and re-shows it.)
    statusEl.innerHTML = '';
    statusEl.style.display = 'none';

    // === TIER MARKERS ON SLIDER ===
    var tierHtml = '';
    for (var i = 0; i < tiers.length; i++) {
      var t = tiers[i];
      var isUnlocked = i <= currentIdx;
      var isCurrent = i === currentIdx;
      var isFree = t.rate === 0;
      var pct = (t.min / freeMin) * 100;

      var cls = 'bb-ship-tier';
      if (isFree) cls += ' bb-ship-tier--free';
      if (isCurrent) cls += ' bb-ship-tier--current';
      else if (isUnlocked) cls += ' bb-ship-tier--unlocked';
      else cls += ' bb-ship-tier--locked';

      var rateLabel = isFree ? 'FREE' : t.label;
      tierHtml += '<div class="' + cls + '" style="left:' + pct + '%">' + rateLabel + '</div>';
    }
    tiersEl.innerHTML = tierHtml;
    // Slider/ladder removed in BOTH contexts (owner 2026-07) — hide it (also
    // hidden via CSS for the paused state). Computation above is now inert.
    var _sliderEl = document.getElementById('bb-ship-slider-' + ctx);
    if (_sliderEl) _sliderEl.style.display = 'none';

    // === HEADER — zone + location ===
    var _rnL = STATE_NAMES[geoState] || geoState;
    var locationStr = geoCity ? (geoCity + ', ' + geoState) : _rnL;
    var dates = getShipDates(geoZone);
    // Formatted ETA range (e.g. "Aug 18–Sep 1") — shared by the merged hero
    // delivery line and the below-hero fallback line.
    var _etaStr = (function(a){var m=(a||'').match(/^([A-Za-z]+) (\d+)\s*[–-]\s*([A-Za-z]+) (\d+)$/);return m?(m[1]===m[3]?m[1]+' '+m[2]+'–'+m[4]:m[1]+' '+m[2]+'–'+m[3]+' '+m[4]):a;})(dates.arrive);
    try { window.BB_ETA = { etaStr: _etaStr }; } catch (e) {}
    // Peak-season subline (Apr-Nov). Off-peak: clean header, no subline. Extended 2026-10-02: the row is branded "Fall Rush" but the window ended 30 Sep, so it switched off exactly as fall began. Months are 0-indexed. ⛔ Hardcoded in BOTH stores — change them together or the two drift.
    var _peakMonths = [] /* Fall Rush RETIRED 2026-11-01 — unbacked scarcity. Refill to revive. */;
    var _isPeak = _peakMonths.indexOf(new Date().getMonth()) !== -1;
    var _bbRegionNames = {"AL":"Alabama","AK":"Alaska","AZ":"Arizona","AR":"Arkansas","CA":"California","CO":"Colorado","CT":"Connecticut","DE":"Delaware","FL":"Florida","GA":"Georgia","HI":"Hawaii","ID":"Idaho","IL":"Illinois","IN":"Indiana","IA":"Iowa","KS":"Kansas","KY":"Kentucky","LA":"Louisiana","ME":"Maine","MD":"Maryland","MA":"Massachusetts","MI":"Michigan","MN":"Minnesota","MS":"Mississippi","MO":"Missouri","MT":"Montana","NE":"Nebraska","NV":"Nevada","NH":"New Hampshire","NJ":"New Jersey","NM":"New Mexico","NY":"New York","NC":"North Carolina","ND":"North Dakota","OH":"Ohio","OK":"Oklahoma","OR":"Oregon","PA":"Pennsylvania","RI":"Rhode Island","SC":"South Carolina","SD":"South Dakota","TN":"Tennessee","TX":"Texas","UT":"Utah","VT":"Vermont","VA":"Virginia","WA":"Washington","WV":"West Virginia","WI":"Wisconsin","WY":"Wyoming","DC":"D.C."};
    var _bbLocale = (geoCity && String(geoCity).trim()) ? String(geoCity).trim() : ((geoState && _bbRegionNames[geoState]) ? _bbRegionNames[geoState] : '');
    /* ⭐ published so the slide-cart Fall Rush STAND-IN can name the town too. The stand-in
       lives in bb-cart-monitor.js and had no geo of its own, which is why the cart said
       "the next truck" while the PDP said "the next truck to Beverly Hills". */
    try { window.BB_LOCALE = _bbLocale; } catch (e) {}
    var _routePhrase = _bbLocale ? ('Spots on the next truck to ' + _bbLocale + ' are filling fast') : 'Spots on the next outbound truck are filling fast';
    var _trustBadges = '<div style="padding:8px 14px 10px;border-top:1px solid rgba(0,0,0,.06);text-align:center;">'
      + '<button type="button" aria-expanded="false" onclick="var p=this.nextElementSibling;var o=p.style.display===\'none\';p.style.display=o?\'block\':\'none\';this.setAttribute(\'aria-expanded\',o?\'true\':\'false\');var c=this.querySelector(\'[data-bb-lanecaret]\');if(c)c.textContent=o?\'\u25B4\':\'\u25BE\';" style="background:none;border:0;padding:2px 0 0;margin:0;cursor:pointer;font:inherit;font-size:13px;font-weight:600;opacity:1;color:inherit;display:inline-flex;align-items:center;gap:4px;justify-content:center;">'
      + '\uD83D\uDE9A Save on Freight &amp; Get it Sooner <span data-bb-caret data-bb-lanecaret style="font-size:9px;">\u25BE</span></button>'
      + '<div style="display:none;font-size:11.5px;line-height:1.55;opacity:.9;margin-top:6px;text-align:center;">'
      + '<div style="margin-bottom:4px;"><strong>Light</strong> &mdash; unframed panels, wire and rolls. Lower freight rate, arrives sooner.</div>'
      + '<div><strong>Heavy</strong> &mdash; framed panels, gates and Zero-Maintenance. Higher freight rate, takes longer.</div>'
      + ''
      + ''
      + '</div></div>';
    var _subline = (_isPeak) ? '<div style="padding:8px 14px 10px;border-top:1px solid rgba(0,0,0,.06);text-align:center;"><button type="button" aria-expanded="false" onclick="var p=this.nextElementSibling;var o=p.style.display===\'none\';p.style.display=o?\'block\':\'none\';this.setAttribute(\'aria-expanded\',o?\'true\':\'false\');var c=this.querySelector(\'[data-bb-caret]\');if(c)c.textContent=o?\'▴\':\'▾\';" style="background:none;border:0;padding:2px 0 0;margin:0;cursor:pointer;font:inherit;font-size:13px;font-weight:600;opacity:1;color:inherit;display:inline-flex;align-items:center;gap:4px;justify-content:center;">🍂 Fall Rush — Reserve Your Spot. <span data-bb-caret style="font-size:9px;">▾</span></button><div class="bb-peak-collapse" style="display:none;"><div style="font-size:11px;opacity:0.9;margin-bottom:6px;text-align:center;line-height:1.4;">' + _routePhrase + ' \u2014 most orders ship earlier than the window above.</div><div style="font-size:10px;opacity:0.7;margin-top:5px;text-align:center;">Book your installer only after shipment confirmation.</div></div></div>' : '';
    if (headerEl) {
      var homeownerBadge = '';
      var _dpHero = '';
      try {
        if (bbRates()[geoZone] && cartTotal >= 0) {
          var _dpT = bbRates()[geoZone];
          var _dpMin = _dpT[0].min;                    // zone's lowest-tier minimum (real, per-zone)
          var _emptyCart = cartTotal === 0;            // standing "add $X for free delivery" prompt
          var _belowMin = cartTotal < _dpMin;
          /* ⭐ GATE THE TWO-TRUCK BOX HERE, inline. Under the floor there is no delivery, so the
             box must not describe how it splits. Deliberately NOT a MutationObserver: the earlier
             observer version fed itself and took the site down. renderElement already runs on
             every cart and geo change, which is exactly when this can change.
             ⚠️ Only ever hides — bb-cart-monitor.js hides the same element for paused regions. */
          try {
            if (_belowMin) {
              var _mxN = document.querySelectorAll('[data-bb-mixnote]');
              for (var _mxI = 0; _mxI < _mxN.length; _mxI++) _mxN[_mxI].style.display = 'none';
            }
          } catch (e) {}
          /* ⭐ ONE SOURCE for "does this cart qualify" — the two-truck box reads this, so it can
             never disagree with the chip about whether delivery exists yet. */
          try { window.BB_BELOW_MIN = _belowMin; } catch (e) {}          // under the regional minimum -> no delivery rate yet
          var _dpI = getCurrentTierIndex(geoZone, cartTotal);
          // At/above the minimum a tier matches -> real delivery rate; below it, no rate is added.
          var _dpR = (!_belowMin && _dpI >= 0 && _dpI < _dpT.length) ? _dpT[_dpI].rate : 0;
          var _dpFree = !_belowMin && _dpR === 0;
          // FREE-DELIVERY THRESHOLD — derived from the rate table, never hardcoded: the first
          // tier priced at 0. Follows any reprice of the freight card automatically.
          var _dpFreeAt = 0;
          for (var _fi = 0; _fi < _dpT.length; _fi++) { if (_dpT[_fi].rate === 0) { _dpFreeAt = _dpT[_fi].min; break; } }
          var _dpShort = _dpFreeAt > 0 ? (_dpFreeAt - cartTotal) : 0;
          var _dpChasing = _dpFreeAt > 0 && _dpShort > 0;
          // The nudge REPLACES the trust tail while chasing (owner: the two lines said the same
          // thing). Trust copy returns once the threshold is cleared and no nudge is left.
          // "FREE delivery" uses the ratetoken class, not <strong> — the class is
          // {color:#EB673C;font-weight:700}, so it goes ORANGE and stays bold, pairing with the
          // already-orange gap amount. "we unload" is the moat phrase in the shortest form that
          // fits the slide cart (~52 ch); both lines below are 40-42. NEVER "curb"/"curbside".
          // ⛔ NO GAP CLAUSE HERE. The rail below shows "$X to go" on the pill; repeating it in
          // words is the same fact twice, 20px apart — that is what killed the first rail.
          /* ⛔ do NOT repeat the card header ("MADE, MOVED & UNLOADED BY US") — it read twice on one
             screen. These two facts are the ones the header does not carry. */
          var _dpTrust = '<span style="display:block;margin-top:5px;font-size:11px;font-weight:700;letter-spacing:0.2px;color:#111111;line-height:1.35">Factory Direct &middot; No Surcharges &middot; Freight Insured</span>';
          // MIXED CART — the cart spans both delivery profiles and Shopify SUMS THEM, so explain
          // the two fees and give the lever that removes one: match the product type, don't mix.
          // Splitting into two orders does NOT help (each order carries its own lane) — only a
          // single-type cart pays a single fee, so that is what we say.
          // Both rates are read from the live ladders at THIS cart's band index, so a reprice can
          // never leave this sentence quoting a number checkout no longer charges.
          try {
            // A mixed cart is charged BOTH delivery profiles — the fees STACK. This runs below the
            // $500 minimum too, because the panel prints a rate there and a number with no reason
            // beside it is the whole complaint. Rendered as separate lines rather than a sentence:
            // the cart is the last place the shopper can act on this, so it must scan at a glance.
            if (bbCartMixedNow() && !_emptyCart) {
              // getCurrentTierIndex() returns -1 BELOW the lowest band, and RATES[zone][-1] is
              // undefined — which silently collapsed both fees to 0 and printed "both delivered
              // FREE" on a $499.98 cart that cannot even check out. Clamp to the first band, the
              // same fallback _dpShowR uses, so the sentence always matches the price beside it.
              var _bbI = (_dpI >= 0) ? _dpI : 0;
              var _bbQS = (RATES[geoZone] && RATES[geoZone][_bbI]) ? RATES[geoZone][_bbI].rate : 0;
              var _bbCR = (CRANE_RATES[geoZone] && CRANE_RATES[geoZone][_bbI]) ? CRANE_RATES[geoZone][_bbI].rate : 0;
              var _bbQSn = '', _bbCRn = '';
              // Second, independent guard: below the minimum there is NO rate at all, so the free
              // band cannot apply no matter what the ladder lookup returned.
              if (!_belowMin && (_dpFree || (_bbQS === 0 && _bbCR === 0))) {
                // At/above the free band BOTH lanes are $0 — there is no freight to save and
                // nothing to explain, so the panel keeps its default trust line untouched. Replacing
                // it here was the same bug as before: losing the moat line to say something the
                // shopper does not need.
              } else {
                // Consolidating to ONE lane drops the LARGER fee (an all-Quick-Ship cart pays the
                // small one), so the saving is max(), not the sum and not the difference.
                // The saving is THE FEE YOU DROP, not the larger of the two. Consolidating onto
                // Loose Truck removes the CRANE fee, so the saving is _bbCR by construction — true
                // at any future rate. Going all-crane would save only _bbQS, which is exactly why
                // the line below has to NAME the lane rather than say "one type" and imply either.
                // Each option's saving is THE FEE IT DROPS — never the larger fee, never a single
                // number for both. Quick-only drops the crane fee; crane-only drops the quick fee.
                // Each option's saving is THE FEE IT DROPS. Quick-only drops the crane fee;
                // crane-only drops the quick fee. Never one figure for both — that was wrong by
                // $100 for anyone who consolidated the other way.
                var _bbSaveQ = _bbCR, _bbSaveC = _bbQS;
                // Capture the default trust copy BEFORE overwriting _dpTrust — assigning over it is
                // what silently dropped "We Unload · no surcharges, freight insured" from every
                // mixed cart, the one claim here no competitor can make.
                var _bbTrust0 = _dpTrust;
                var _bbLn = 'display:block;text-align:center;';
                // Detail, hidden until asked for.
                // Label left, price right — a price COLUMN is scannable; a price buried mid-sentence
                // is not. Bold is spent on the two amounts only (600, not 700); the savings and the
                // supporting lines are muted 11px. One level of emphasis instead of four.
                // Declared HERE deliberately: this string's previous declaration lived in a layout
                // that was replaced, and the reference outliving it threw a ReferenceError that the
                // enclosing try/catch swallowed — silently killing the whole dropdown.
                var _bbNW = 'white-space:nowrap;';
                var _bbRow = function (label, amt, note) {
                  // ⛔ The opening string MUST stay on the same line as the "return" keyword. A comment
                  // between them triggers automatic semicolon insertion (an empty "return;") and the row
                  // then silently renders as
                  // 'undefined'. node --check passes, because it is valid JavaScript. Caught only by
                  // executing the block (_freight_block_smoketest.mjs).
                  // Tight line-height: the two options are one comparison and should read as a pair.
                  return '<span style="display:flex;justify-content:space-between;align-items:baseline;gap:12px;line-height:1.35;">' +
                    '<span>' + label + '</span>' +
                    '<span style="' + _bbNW + '"><span style="font-weight:600;">' + amt + '</span>' +
                    '<span style="opacity:.6;font-size:11px;margin-left:6px;">' + note + '</span></span></span>';
                };
                // Centred (owner): the two supporting lines read as sentences, not columns — only the two
                // option ROWS below keep left/right alignment, because those are a price column.
                var _bbMuted = 'display:block;text-align:center;opacity:.7;font-size:11px;line-height:1.45;';
                var _bbDetail =
                  // The WHY. The rows below already name both categories, so the sentence does not.
                  '<span style="' + _bbMuted + 'margin-bottom:4px;">Freight is charged per category ' +
                  '&mdash; your cart has both.</span>' +
                  // Constrained width, centred (owner: bring the labels closer TO THE PRICES). space-between
                  // across the full panel pushed each label and its price to opposite edges; capping the
                  // row keeps the price COLUMN aligned — so the two options still compare cleanly —
                  // while closing the gap between a label and its own number.
                  '<span style="display:block;text-align:left;max-width:250px;margin:0 auto;">' +
                  _bbRow(_bbQSn + ' only', money(_bbQS), 'save ' + money(_bbSaveQ)) +
                  _bbRow(_bbCRn + ' only', money(_bbCR), 'save ' + money(_bbSaveC)) +
                  '</span>';
                if (!_belowMin && _dpChasing && _dpShort > 0) {
                  // Gap CEILINGS to the dollar exactly as the rail pill does; plain money() rounds
                  // DOWN and would advertise a gap smaller than the real one.
                  _bbDetail += '<span style="' + _bbMuted + 'margin-top:5px;">Or add ' +
                    money(Math.ceil(_dpShort / 100) * 100) + ' and both ship free.</span>';
                }
                // Same collapse mechanic as the peak-season block above: inline onclick, sibling
                // span, caret swap. The sibling MUST stay immediately after the button.
                // Order matters (owner): the number, then the moat line, THEN the little button.
                // Collapsed, the panel reads exactly as it did before any of this existed.
                var _bbTxt = '<span style="' + _bbLn + '">' + _bbTrust0 + '</span>' +
                  '<span style="' + _bbLn + 'margin-top:5px;">' +
                  '<button type="button" aria-expanded="false" onclick="var p=this.parentNode.nextElementSibling;var o=p.style.display===\'none\';p.style.display=o?\'block\':\'none\';this.setAttribute(\'aria-expanded\',o?\'true\':\'false\');var c=this.querySelector(\'[data-bb-caret]\');if(c)c.textContent=o?\'\u25B4\':\'\u25BE\';" ' +
                  'style="background:none;border:0;padding:0;margin:0;cursor:pointer;font:inherit;font-size:12px;font-weight:600;color:inherit;text-decoration:underline;text-underline-offset:2px;display:inline-flex;align-items:center;gap:4px;">' +
                  'How to save on freight <span data-bb-caret style="font-size:9px;">\u25BE</span></button></span>' +
                  '<span class="bb-frt-collapse" style="display:none;margin-top:5px;">' + _bbDetail + '</span>';
                _dpTrust = _bbTrust0; /* toggle moved to the bottom strip (_bbTogs) */
              }
            }
          } catch (e) {}
          var _dpDisc = (window.BB_DISCOUNT && window.BB_DISCOUNT.rate) ? window.BB_DISCOUNT.rate : 0;
          var _dpPay = (window.BB_DISCOUNT && window.BB_DISCOUNT.paymentMethod) ? window.BB_DISCOUNT.paymentMethod : 'bank transfer';
          // ACH hint on the subtotal; suppressed on an empty cart (no price to discount).
          var _dpHint = (/* BB 2026-10-23 owner: bank hint RESTORED under the total, above the BARRIERBOSS/Others toggle */ !_emptyCart && !_belowMin && _dpDisc > 0) ? '<span class="bb-ship-allin__ach" style="display:block;margin:10px 0 5px;line-height:1.4;font-size:12px;text-wrap:balance"><svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" style="vertical-align:-2px;margin-right:6px;opacity:.9" aria-hidden="true" focusable="false"><path d="M12 2 1 8v2h22V8zM4 12v7H2v2h20v-2h-2v-7h-2v7h-3v-7h-2v7h-2v-7H9v7H6v-7z"/></svg><strong>Save ' + Math.round(_dpDisc*100) + '%</strong> with <span style="font-weight:700">Bank Deposit</span> at&nbsp;Checkout</span>' : '';
          // DYNAMIC delivered line (2026-07): at/above the zone minimum it reads the
          // normal "Delivered & Unloaded ... for FREE|$X"; below the minimum (incl.
          // an empty cart, where need = the full minimum) it flips to a cart-building
          // Below the minimum there is NO sentence any more — the rail's left cap says
          // "$MIN / minimum" and that is the only place the floor is stated (owner 2026-08-01).
          if(!document.getElementById('bb-dtog-style')){try{var _bbds=document.createElement('style');_bbds.id='bb-dtog-style';_bbds.textContent='.bb-pt{display:block;margin-top:3px;}.bb-pt .bb-pt-r{position:absolute;width:0;height:0;opacity:0;pointer-events:none;}.bb-pt-seg{display:inline-flex;align-items:center;background:#f2f2f3;border:1px solid #e5e5e7;border-radius:8px;padding:2px;gap:2px;}.bb-pt-opt{cursor:pointer;margin:0;font-size:10px;font-weight:700;padding:2px 10px;border-radius:6px;color:#8a9099;line-height:1.55;min-width:92px;text-align:center;box-sizing:border-box;-webkit-user-select:none;user-select:none;letter-spacing:.2px;transition:background .12s,color .12s;}.bb-pt-body{display:none;font-size:12px;line-height:1.35;font-weight:600;margin-top:6px;min-height:2.7em;padding:8px 10px;margin-left:-12px;margin-right:-12px;border-radius:10px;border:1px solid transparent;box-sizing:border-box;}.bb-pt-body--us{color:#151515;background:rgba(235,103,60,0.06);}.bb-pt-body--them{color:#8a9099;background:rgba(0,0,0,.035);}.bb-pt-body--them:has(.bb-drs-track){color:#4a4a4a;}.bb-drs-wrap{display:flex;align-items:stretch;gap:2px;}.bb-drs-track{flex:1 1 auto;min-width:0;display:flex;overflow-x:auto;scroll-snap-type:x mandatory;scroll-behavior:smooth;-webkit-overflow-scrolling:touch;overscroll-behavior-x:contain;scrollbar-width:none;}.bb-drs-track::-webkit-scrollbar{display:none;}.bb-drs-slide{flex:0 0 100%;scroll-snap-align:center;box-sizing:border-box;padding:2px 4px 0;font-size:12px;line-height:1.45;color:#4a4a4a;font-weight:500;overflow-wrap:break-word;word-break:break-word;align-self:flex-start;}.bb-drs-track{transition:height .18s ease;align-items:flex-start;}.bb-drs-nav{flex:0 0 auto;width:22px;border:0;background:none;padding:0;margin:0;cursor:pointer;color:#B34518;font-size:19px;line-height:1;font-weight:700;border-radius:6px;-webkit-user-select:none;user-select:none;}.bb-drs-nav:hover{background:rgba(235,103,60,.10);}.bb-drs-nav:active{background:rgba(235,103,60,.18);}.bb-drs-w{display:block;font-size:10.5px;color:#888;margin-top:3px;font-weight:600;}.bb-pt-r--us:checked~.bb-pt-seg .bb-pt-opt--us{background:#EB673C;color:#fff;}.bb-pt-r--us:checked~.bb-pt-body--us{display:block;}.bb-pt-r--them:checked~.bb-pt-seg .bb-pt-opt--them{background:#5f6368;color:#fff;}.bb-pt-r--them:checked~.bb-pt-body--them{display:block;}';document.head.appendChild(_bbds);}catch(e){}} if(!window.__bbDtogInit){window.__bbDtogInit=1;try{document.addEventListener('change',function(_ev){var _t=_ev.target;if(_t&&_t.classList&&_t.classList.contains('bb-pt-r')){var _mm=String(_t.id||'').match(/^bbpt-(us|them)-(.+)$/);if(_mm){window.__bbDtog=window.__bbDtog||{};window.__bbDtog[_mm[2]]=_mm[1];}}});}catch(e){}} var _dpShowR = _belowMin ? _dpT[0].rate : _dpR;
          // Always "for" (owner 2026-07-31). The rate card is FLAT — $49 / $149 everywhere — so
          // there is no range to hedge with "from", and "from" reads as "it could be more".
          // Restore the _belowMin ternary here if a banded/zoned card ever comes back.
          var _dpFW = 'for';
          /* ⭐ MIXED BREAKDOWN 2026-10-16 — see _mixed_breakdown.mjs. Same tables as getShipDates. */
          function _bbLaneWin(crane){
            try{
              var _zn = ZONES[geoState];
              if (_zn && typeof bbIsNewZone === 'function' && bbIsNewZone(_zn)) {
                var _t = crane
                  ? (typeof ZONE_ETA_C !== 'undefined' ? ZONE_ETA_C[_zn] : (typeof ZONE_ETA !== 'undefined' ? ZONE_ETA[_zn] : null))
                  : (typeof ZONE_QS_ETA !== 'undefined' ? ZONE_QS_ETA[_zn] : null);
                if (_t && _t.length > 1) return _t;
              }
              if (typeof _LT !== 'undefined' && _LT[geoState]) {
                var _z = _LT[geoState];
                return crane ? [_z[0], _z[1]] : [_z[2], _z[3]];
              }
            }catch(e){}
            return null;   /* ⛔ no window rather than a guessed one */
          }
          function _bbWk(w){ return (w && w.length > 1) ? (Math.round(w[0]/5) + '\u2013' + Math.round(w[1]/5) + ' wks') : ''; }
          var _dpBreak = '';
          /* ⭐ "$149 + $199" instead of "$348" — same money, read as two deliveries rather than a
             surcharge. Empty on a single-lane cart, which keeps its single figure. */
          var _mixPairTxt = '';
          try {
            if (bbCartMixedNow()) {
              var _zq = ZONES[geoState];
              var _lr = (RATES[_zq] && RATES[_zq][0]) ? RATES[_zq][0].rate : null;
              var _hr = (CRANE_RATES[_zq] && CRANE_RATES[_zq][0]) ? CRANE_RATES[_zq][0].rate : null;
              if (_lr !== null && _hr !== null) {
                /* ⭐ same function the "Arrives in ..." line uses, lane forced — never a second date path */
                var _lw = '', _hw = '';
                try { var _dL = getShipDates(null, 'q'); if (_dL && _dL.arrive) _lw = _dL.arrive; } catch(e){}
                try { var _dH = getShipDates(null, 'c'); if (_dH && _dH.arrive) _hw = _dH.arrive; } catch(e){}
                /* ⛔ Tier block REMOVED 2026-10-26 (owner: "get rid of this its chaos"). The card
             states the one rate that applies; the ladder lives on the shipping page and llms.txt. */
          try {
                  var _lvP = ((window.__bbCartLaneValues || {}).light) | 0,
                      _hvP = ((window.__bbCartLaneValues || {}).heavy) | 0;
                  var _pickP = function (t, cents) { var r = t[0].rate; for (var i = 0; i < t.length; i++) if (cents >= t[i].min) r = t[i].rate; return r; };
                  var _lrP = (RATES[_zq] && RATES[_zq].length) ? _pickP(RATES[_zq], _lvP) : _lr;
                  var _hrP = (CRANE_RATES[_zq] && CRANE_RATES[_zq].length) ? _pickP(CRANE_RATES[_zq], _hvP) : _hr;
                  _mixPairTxt = (_lrP === 0 ? 'FREE' : money(_lrP)) + ' + ' + (_hrP === 0 ? 'FREE' : money(_hrP));

                } catch (e) {}
              }
            }
          } catch(e){}
          /* ⛔⛔ THE PDP NEVER SAID THERE IS A FLOOR. The rail's left cap carried it and the rail
             was pulled today, so a $300 cart could see a delivery price for an order checkout
             will refuse. Reuses the same in-between slot: empty on a single-lane cart, and a
             mixed cart keeps its breakdown because the ladder explains the price it can see.
             ⛔ Gap rounds UP — money() floors, which would name a gap a dollar short of the floor
                and leave the shopper blocked after doing exactly what they were told. */
          /* ⛔⛔ THE MINIMUM WINS OVER THE BREAKDOWN. First written as "only if the slot is free",
             which meant a MIXED cart under the floor — the owner's own $326 cart — showed
             "Light $149 + Heavy $199 · pick one to save $149" and never the blocker. A rate the
             store will refuse must not outrank the reason it will refuse it. */
          try {
            if (_belowMin && _dpMin > 0) {
              var _minGap = Math.ceil((_dpMin - cartTotal) / 100) * 100;
              /* ⭐ the rate token already states the floor, so this line carries the ACTION.
                 On an empty cart there is no gap to close, so it states the rule instead. */
              _dpBreak = '<span style="display:block;margin:1px 0 2px;font-size:11.5px;font-weight:600;opacity:.9">'
                + ((cartTotal > 0 && _minGap > 0)
                    ? ('add <span style="color:#EB673C;font-weight:800">' + money(_minGap) + '</span> to unlock delivery')
                    : ('orders start at <span style="color:#EB673C;font-weight:800">' + money(_dpMin) + '</span>'))
                + '</span>';
            }
          } catch (e) {}
          /* ⭐ THE REMAINING LADDER, one line (owner: "Drops to $148 at $2,500 · FREE at $5,000").
             Read off the same tier table the headline prices from, so Light-only, Heavy-only and
             mixed each print their own figures and the mixed pair sums to the number above it.
             Only bands AHEAD of this cart, and only where the rate actually falls — past $2,500
             it reduces to the free tier, past $5,000 it disappears.
             ⛔ Silent below the minimum: the slider owns that state. */
          try {
            if (!_belowMin) {
              var _ndParts = [], _ndPrev = _dpR;
              for (var _ndI = 0; _ndI < _dpT.length; _ndI++) {
                if (_dpT[_ndI].min > cartTotal && _dpT[_ndI].rate < _ndPrev) {
                  _ndParts.push(_dpT[_ndI].rate === 0
                    ? ('<span style="color:#EB673C;font-weight:800">FREE</span> at ' + (money(_dpT[_ndI].min) + '+'))
                    : ('Drops to <span style="color:#EB673C;font-weight:800">' + money(_dpT[_ndI].rate) + '</span> at ' + (money(_dpT[_ndI].min) + '+')));
                  _ndPrev = _dpT[_ndI].rate;
                }
              }
              if (_ndParts.length) {
                _dpBreak = '<span style="display:block;margin:1px 0 2px;font-size:11.5px;font-weight:600;opacity:.85">'
                  + _ndParts.join(' &middot; ') + '</span>';
              }
            }
          } catch (e) {}
          /* ⭐ ONE-LINE FREE MESSAGE (owner 2026-10-28: "is there any way to one line free
             shipping without the slider?"). Replaces the ~64px slider with ~16px of text, rendered
             inside the delivery row directly beneath the rate — the rate and the way to remove it
             read as one thought.
             ⭐ THE THRESHOLD IS DERIVED from the first zero-rate band in the live tier table, so a
                reprice moves it and there is no $5,000 typed anywhere here.
             ⛔ Silent below the order minimum: down there the blocker is the $500 floor, which the
                row already states, and a free-delivery nudge would be answering the wrong question. */
          _dpBreak = '';
          var _dpFreeTail = '';
          try {
            if (!_belowMin) {
              var _fAt = 0;
              for (var _fi = 0; _fi < _dpT.length; _fi++) {
                if (+_dpT[_fi].rate === 0 && _dpT[_fi].min > 0) { _fAt = _dpT[_fi].min; break; }
              }
              if (_fAt > 0 && _fAt > cartTotal) {
                /* inline tail on the rate line, not its own row (owner 2026-10-28) */
                _dpFreeTail = ' &middot; <span style="color:#111111;font-weight:800">Free '
                  + '<span style="color:#EB673C">' + money(_fAt) + '+</span></span>';
              }
            }
          } catch (e) {}

          /* ⭐ 2026-11-04 (owner): under the minimum the strip named ONLY the floor, so a shopper
             with an empty cart could not see what delivery costs or when it becomes free. Both
             figures are read off the live ladder _dpT — never hardcoded. Its OWN LINE: the row
             above wrapped at 304px when these were inlined (see the 2026-11-01 note there). */
          /* ⭐ 2026-11-04 (owner, restyle): the strip leads with the VALUE — "for <rate> Flat or
             Free <threshold>+" — with ONLY the figures in orange, and the order minimum demoted
             to the head of the trust row. Both figures are read off the live ladder _dpT; this
             file holds no rate of its own. ⚠️ Width: the 2026-11-01 note on the row above records
             that this shape wrapped at 304px against ~295px. Measured on the rendered page. */
          var _dpBelowLine = '', _bRowTail = '';
          try {
            if (_belowMin) {
              var _bFlat = 0, _bFree = 0;
              for (var _bi = 0; _bi < _dpT.length; _bi++) {
                if (!_bFlat && +_dpT[_bi].rate > 0) _bFlat = +_dpT[_bi].rate;
                if (!_bFree && +_dpT[_bi].rate === 0 && _dpT[_bi].min > 0) _bFree = _dpT[_bi].min;
              }
              var _o1 = '<span style="color:#EB673C">', _o2 = '</span>';
              if (_bFlat > 0) {
                _bRowTail = ' for ' + _o1 + money(_bFlat) + _o2
                  + (_bFree > 0 ? ' or Free ' + _o1 + money(_bFree) + '+' + _o2 : '');
              }
              /* minimum leads the trust row; _dpTrust itself is never mutated, so the
                 at-or-above-minimum strip is unaffected. */
              var _bMin = money(_dpMin) + ' Order Minimum';
              _dpBelowLine = '<span style="display:block;margin-top:4px;font-size:11px;font-weight:700;letter-spacing:0.2px;color:#111111;line-height:1.35">' + _o1 + money(_dpMin) + _o2 + ' Order Minimum</span>';
            }
          } catch (e) {}
          var _bbSvc = 'Delivered & Unloaded'; /* ⛔ ONE LANE (2026-11-01): Mixed/Heavy/Light all billed $99 from a single profile, so three labels for one rate is a distinction the customer cannot act on. */ /* ⛔ NO LONGER TRUNCATED (owner 2026-11-01). This stripped "Residential " whenever the free tail showed, so the row read "Delivery · $99 · Free $2,500+" — the owner asked for the full name. The ~36ch mobile budget is still real; the free tail is what gives way, not the name. */ /* 2026-10-30: 3-segment row busts the ~36ch mobile budget; shorten ONLY when the free tail shows. */ var _bbEtaLn = '<span class="bb-ship-allin__etaline" style="display:block;margin:0 0 11px;font-size:12px;font-weight:600;">Arrives' + (locationStr ? ' in ' + locationStr : '') + ' · <span class="bb-ship-allin__eta">' + _etaStr + '</span> · <a href="#" class="bb-ship-change" data-bb-reset>change</a></span>';
          var _dpToggle = '<span class="bb-pt">' + '<input type="radio" name="bbpt-' + ctx + '" id="bbpt-us-' + ctx + '" class="bb-pt-r bb-pt-r--us"' + ((window.__bbDtog&&window.__bbDtog[ctx])==='them'?'':' checked') + '>' + '<input type="radio" name="bbpt-' + ctx + '" id="bbpt-them-' + ctx + '" class="bb-pt-r bb-pt-r--them"' + ((window.__bbDtog&&window.__bbDtog[ctx])==='them'?' checked':'') + '>' + '<span class="bb-pt-seg"><label for="bbpt-us-' + ctx + '" class="bb-pt-opt bb-pt-opt--us">Delivery</label><label for="bbpt-them-' + ctx + '" class="bb-pt-opt bb-pt-opt--them">Reviews</label></span>' + '<span class="bb-pt-body bb-pt-body--us"><strong style="display:block;margin-bottom:7px;font-size:12.5px;line-height:1.35">\uD83D\uDE9A ' + _bbSvc + (_belowMin ? _bRowTail : (' for ' + '<span class="bb-ship-allin__ratetoken">' + (_dpShowR === 0 ? 'Free' : money(_dpShowR)) + '</span>' + _dpFreeTail)) + '</strong>' /* ⛔ free tail removed from the row 2026-11-01: "for $99 Flat · Free $2,500+" is 304px against ~295px and wrapped. The threshold still shows on the price line, in the FAQ and at checkout. */ + _dpBreak + _dpBelowLine + _dpTrust + '</span>' + _bbDrsPanel() + '</span>';
          var _dpDelivered = _belowMin
            // Below the minimum: the RAIL states the floor on its left cap ("$500 / minimum"), so
            // repeating it in a sentence is the same fact twice. Branch kept, not merged: down here
            // _dpR is 0 and _dpFree is false, so the chasing test would fall through to the
            // free-state line and wrongly print "Residential Delivery for FREE".
            ? _dpToggle
            : _dpToggle;   /* ⭐ ALWAYS the comparison (owner 2026-10-28). It used to vanish on a free cart,
                   which is the one cart where "they charge ~$199, we charge nothing" IS the argument. */
          // Empty cart: suppress the price + "all-in before discounts" cap (nothing
          // in the cart, no "$0 all-in") — show ONLY the nudge + ETA + change.
          /* ⛔⛔ BELOW THE FLOOR COUNTS AS "NO DELIVERY", NOT AS "DELIVERY INCLUDED". This branched
             on _emptyCart alone, so a $326 cart printed its own total under the words "includes
             delivery & unloading" — while the slider immediately beneath it said "$500 to go / to
             unlock delivery". One card, two contradictory claims, and the false one was the big
             number. Under the floor _dpR is 0, so nothing was being included at all.
             ⭐ Below the minimum we now show the cart total and CALL it the cart total; only once
                delivery actually applies does the label claim to include it. */
          var _dpPriceCap = (_emptyCart || _belowMin) ? ('<span class="bb-ship-allin__price">' + money(_emptyCart ? 0 : cartTotal) + '</span>' + '<span class="bb-ship-allin__cap">cart total</span>') : ('<span class="bb-ship-allin__price">' + money(cartTotal + _dpR) + '</span>' + '<span class="bb-ship-allin__cap">includes delivery &amp; unloading</span>');
          // Money stack (owner 2026-07): price -> compact ACH second price -> merged
          // delivery/nudge line + ETA + change (price/cap dropped on empty cart).
          // TIER STRIP (owner 2026-10-26, replacing "Pill on rail"). Rendered here, inside
          // _dpHero, because the estimator repaints this container and would wipe an injected node.
          //   one equal segment per DISTINCT rate; the active one is filled. Derived, never hardcoded.
          // Caps DERIVED: _dpMin (_dpT[0].min) and _dpFreeAt (first tier rate===0). Never hardcode.
          var _dpProg = '';
          // Renders on an EMPTY cart too (owner 2026-08-01) — that is the state a first-time
          // visitor lands in, and the offer has to be visible to the people it is meant to recruit.
          // ⭐ 2026-10-26: the proportional rail is now an EQUAL-SEGMENT TIER STRIP. At $0 the first
          // segment is simply the active one, so there is no percentage to floor and nothing to clamp.
          // ⭐ RAIL VALUE GATE (owner 2026-09-30, to shorten the PDP). The rail is ~110px — the tallest
          // single element in the card — and in Zone 1 it argues AGAINST the sale: "spend $1,426 more
          // to save $99". It only earns its height where the free tier is worth real money.
          //   _belowMin  -> ALWAYS show. Below $500 the rail is not an upsell, it is the ORDER
          //                 MINIMUM, a checkout blocker, and its left cap is where that is stated.
          //   _dpR       -> the delivery rate this cart would avoid, in CENTS. Reading the live rate
          //                 instead of the zone id means it self-adjusts per zone AND per lane
          //                 (loose vs crane) with no zone table to keep in sync.
          // At 24900 the rail shows for Z3/Z4 ($249-$399) and hides for Z1/Z2 ($49-$199) and for
          // carts already free (_dpR is 0 there, and the delivery line already reads FREE).
          /* ⛔ WAS `_railMinValue = 24900`, WHICH THE FLAT CARD MADE UNREACHABLE (owner
             2026-10-04: "I need the free over $5,000 one also"). _dpR is 14900 on every cart
             now, so `_dpR >= 24900` was never true and the rail only ever rendered through
             _belowMin — the "$500 minimum" version. 24900 was calibrated for the FOUR-ZONE
             card, where Z3/Z4 were $249-$399.
             ⭐ Derived from the LIVE rate, not a fresh constant: the rail earns its ~110px
                wherever the cart is below the minimum, or there is a real rate to avoid AND a
                free tier to reach. Nothing is pinned to 149, so a reprice cannot kill it again. */
          /* ⛔ RAIL RETIRED 2026-10-05. Both of its caps became false with the four-band card:
             there is no $500 order minimum and no free-over-$5,000 tier. Gated off here rather
             than deleted, so restoring it is one line if a free tier ever returns. */
          var _railWorth = (cartTotal < _dpMin) || (_dpR > 0 && _dpFreeAt > _dpMin);
          if (_railWorth && (cartTotal < _dpMin || _dpFreeAt > _dpMin)) {
            // TWO-STAGE (owner 2026-08-01): below the order minimum the rail targets the
            // MINIMUM, not FREE — that is the milestone actually blocking the shopper. It
            // re-targets to FREE the moment $500 is crossed. One decision, read by everything below.
            /* ⭐ TARGET THE NEXT MILESTONE, NOT ONLY FREE (owner 2026-10-26). The ladder has TWO
               drops now — $149 -> $49 at $1,000, then FREE at $3,500 — and a rail that only ever
               marked FREE hid the nearer, far more winnable one. DERIVED from the live tier table,
               so a reprice moves it with no constant to maintain. */
            var _dpNextAt = 0, _dpNextRate = -1;
            for (var _ni = 0; _ni < _dpT.length; _ni++) {
              if (_dpT[_ni].min > cartTotal && _dpT[_ni].rate < _dpR) {
                _dpNextAt = _dpT[_ni].min; _dpNextRate = _dpT[_ni].rate; break;
              }
            }
            var _rStage1 = cartTotal < _dpMin;
            /* ⭐ SLIDER v2, owner spec 2026-10-26: left cap = $0 (cart), right cap = $3,500+,
               interior tick = cart value over the rate there, pill = gap + the current rate struck
               through to the next one. Pill ABOVE the bar, tick label BELOW — that separation is
               why they no longer collide. */
            /* ⛔⛔ SCALE IS WHY THIS WAS UNREADABLE. On one $0-$5,000 axis a $326 cart put the
               truck at 6% and the $500 gate at 10%, so the only two things that mattered shared the
               first tenth of the bar. Stage 1 spans $0 -> the floor; stage 2 rebases to
               floor -> free. One question per stage. */
            var _rLo = _rStage1 ? 0 : _dpMin;
            var _rHi = _rStage1 ? _dpMin : (_dpFreeAt || _dpNextAt || _dpMin);
            var _dpSpan = Math.max(1, _rHi - _rLo);
            var _dpPct = _dpFree ? 100 : Math.max(2, Math.min(98, Math.round((cartTotal - _rLo) / _dpSpan * 100)));
            var _dpLblPct = Math.max(12, Math.min(86, _dpPct));
            var _dpRightAlign = _dpPct > 80;
            var _dpAnchor = _dpRightAlign
              ? ('right:' + (100 - _dpLblPct) + '%;transform:translateX(12px)')
              : ('left:' + _dpLblPct + '%;transform:translateX(-50%)');
            /* ⛔ STAGE ONE TARGETS THE FLOOR. Below the minimum _dpR is 0, so the "next cheaper tier"
               search can never match and the pill fell through to the far cap — a $326 cart was told
               "$4,674 to go" when $174 was what actually unblocked it. */
            var _dpNextMs = _rStage1 ? _dpMin : ((_dpNextAt > cartTotal) ? _dpNextAt : _rHi);
            var _dpGapTxt = money(Math.ceil(Math.max(0, _dpNextMs - cartTotal) / 100) * 100);
            var _dpBecomes = (_dpNextRate === 0 || _dpNextRate === -1) ? 'FREE' : money(_dpNextRate);
            var _dpCaret = _dpRightAlign ? '' : '<span style="position:absolute;top:100%;left:50%;transform:translateX(-50%);width:0;height:0;border-left:4px solid transparent;border-right:4px solid transparent;border-top:4px solid #EB673C"></span>';
            /* two lines: the ask, then the rate it buys — current struck, next in full */
            /* ⭐ SPLIT PILL (owner 2026-10-28: "move one line above and one below slider so we can
               save some room"). ABOVE = the ask. BELOW = what this cart pays now and what it
               becomes. Two single-line labels need far less vertical gutter than one stacked
               pill, and the space under the bar was empty under a flat card. */
            var _dpPill = _dpFree ? '' : '<span style="position:absolute;bottom:calc(100% + 8px);' + _dpAnchor + ';white-space:nowrap;color:#FFFFFF;background:#EB673C;padding:2px 8px;border-radius:9px;font-size:11px;font-weight:800;line-height:1.2;box-shadow:0 1px 3px rgba(0,0,0,0.18)">'
              + _dpGapTxt + ' to go'
              + _dpCaret + '</span>';
            /* ⛔ Sits BELOW the bar, at the same horizontal anchor as the pill. Under a flat card
               the interior-tick loop emits nothing, so this row is unoccupied — see the header. */
            var _dpUnder = _dpFree ? '' : '<span style="position:absolute;top:calc(100% + 6px);' + _dpAnchor + ';white-space:nowrap;font-size:10.5px;font-weight:800;line-height:1.2;color:#EB673C">'
              + (_rStage1
                  ? 'to unlock delivery'
                  : ('<span style="text-decoration:line-through;opacity:0.5;color:#111111">' + (_dpR > 0 ? money(_dpR) : '') + '</span> \u2192 ' + _dpBecomes))
              + '</span>';

            /* interior ticks: every distinct-rate boundary except the first and the last */
            var _ivSegs = [];
            for (var _si = 0; _si < _dpT.length; _si++) {
              if (!_ivSegs.length || _dpT[_si].rate !== _ivSegs[_ivSegs.length - 1].rate) {
                _ivSegs.push({ min: _dpT[_si].min, rate: _dpT[_si].rate });
              }
            }
            var _ivTicks = '';
            /* ⭐ start at 0 when the first band begins ABOVE the rail's left cap — that boundary is the
               ORDER MINIMUM, the one milestone a short cart can act on. Skipping index 0 was correct
               only while band one started at zero. */
            for (var _sk = (_ivSegs.length && _ivSegs[0].min > _rLo) ? 0 : 1; _sk < _ivSegs.length - 1; _sk++) {
              /* ⛔ a milestone outside this stage would be drawn at 500% and pile onto the cap */
              if (_ivSegs[_sk].min <= _rLo || _ivSegs[_sk].min >= _rHi) continue;
              var _tPct = Math.max(4, Math.min(94, Math.round((_ivSegs[_sk].min - _rLo) / _dpSpan * 100)));
              var _tOn = cartTotal >= _ivSegs[_sk].min;
              _ivTicks +=
                '<span style="position:absolute;top:-4px;left:' + _tPct + '%;width:2px;height:18px;background:#EB673C;opacity:' + (_tOn ? '0.85' : '0.45') + ';transform:translateX(-50%);border-radius:1px"></span>' +
                '<span style="position:absolute;bottom:calc(100% + 4px);left:' + _tPct + '%;transform:translateX(-50%);font-size:10px;font-weight:800;white-space:nowrap;line-height:1.2;color:#111111;opacity:0.6">' + money(_ivSegs[_sk].min) + '</span>' +
                '<span style="position:absolute;top:calc(100% + 3px);left:' + _tPct + '%;transform:translateX(-50%);font-size:11px;font-weight:800;white-space:nowrap;line-height:1.2;color:#EB673C">' + (_sk === 0 ? 'min' : (_ivSegs[_sk].rate === 0 ? 'FREE' : money(_ivSegs[_sk].rate))) + '</span>';
            }

            _dpProg = '<span class="bb-ship-allin__label bb-ship-rail" style="display:block;position:sticky;top:0;z-index:6;background:#FFFFFF;margin:0 -2px 4px;box-shadow:0 2px 6px -4px rgba(0,0,0,0.35);padding-top:' + (_dpFree ? '2px' : '21px') + ';padding-bottom:' + (_dpFree ? '2px' : '26px') + '">' +
              '<span style="display:flex;align-items:center;gap:8px">' +
                '<span style="font-size:11px;font-weight:800;flex:0 0 34px;text-align:right;line-height:1.2;color:#111111;opacity:0.55">' + money(_rLo) + '</span>' +
                '<span style="position:relative;flex:1 1 auto;height:8px;border-radius:99px;background:rgba(0,0,0,0.13)">' +
                  '<span style="display:block;height:100%;width:' + _dpPct + '%;border-radius:99px;background:' + (_dpFree ? '#EB673C' : 'linear-gradient(90deg,#F4A57F,#EB673C)') + '"></span>' +
                  _ivTicks +
                  '<span style="position:absolute;top:50%;left:' + _dpPct + '%;transform:translate(-50%,-50%);font-size:13px;line-height:1;filter:drop-shadow(0 0 2px #FFFFFF) drop-shadow(0 1px 2px rgba(0,0,0,0.35))">\uD83D\uDE9A</span>' +
                  _dpPill +
                  _dpUnder +
                '</span>' +
                '<span style="font-size:11px;font-weight:800;flex:0 0 44px;position:relative;line-height:1.25;text-align:left;color:#111111;opacity:0.7">' + money(_rHi) + (_rStage1 ? '' : '+') +
                  '<span style="position:absolute;top:100%;left:50%;transform:translateX(-50%);margin-top:3px;white-space:nowrap;font-size:10.5px;font-weight:800;color:' + (_dpFree ? '#FFFFFF' : '#EB673C') + ';background:' + (_dpFree ? '#EB673C' : 'transparent') + ';border-radius:99px;padding:' + (_dpFree ? '1px 6px' : '0') + ';opacity:1">' + (_rStage1 ? 'Order Minimum' : 'FREE') + (_dpFree ? ' \u2713' : '') + '</span></span>' +
              '</span></span>';
          }

          /* ── three savings toggles: freight · speed · product (owner 2026-08-16) ──
             Self-contained and wrapped: a throw here must never cost the panel its price. */
          var _bbTogs = '';
          try {
            if (!_emptyCart) {
              var _tI  = (_dpI >= 0) ? _dpI : 0;
              var _tQS = (RATES[geoZone] && RATES[geoZone][_tI]) ? RATES[geoZone][_tI].rate : 0;
              var _tCR = (CRANE_RATES[geoZone] && CRANE_RATES[geoZone][_tI]) ? CRANE_RATES[geoZone][_tI].rate : 0;
              var _tQSn = '', _tCRn = '';
              /* __bbCartLanes is the same source bbCartMixedNow() reads, so the three toggles and
                 the rate line above can never disagree about what is in the cart. */
              var _tL = (window.__bbCartLanes || {});
              var _tMix = !!(_tL.loose && _tL.crane);
              var _tCraneOnly = !!(_tL.crane && !_tL.loose);
              /* Real DATES, never "weeks" (owner). Both lanes go through getShipDates(), which is
                 the SAME function the headline ETA uses — so a lane window can never disagree with
                 the ETA above it, and zone overrides / special-order both still apply. ⛔ Do not
                 recompute dates from _LT here: that would be a second copy of the lead-time model,
                 and Extended zones override it.
                 "Same window" is decided by comparing the two rendered ranges, so Canada's standard
                 provinces (crane and loose both 14–28d) report the truth without a hardcoded rule. */
              var _tDq = getShipDates(geoZone, 'q');
              var _tDc = getShipDates(geoZone, 'c');
              /* ⛔ THE TWO STORES RETURN DIFFERENT SHAPES. Canada's getShipDates returns a
                 "range" key ("Aug 29 – Sep 12"); the USA one has no such key and carries the same
                 string in "arrive". Reading only .range printed "arrives undefined" live on USA
                 while the stubbed test stayed green. Take whichever this store provides.
                 (No backticks in here — this block is injected through a template literal.) */
              var _tLw = (_tDq.range || _tDq.arrive), _tCw = (_tDc.range || _tDc.arrive);
              var _tSame = (_tLw === _tCw);
              /* Owner: "black text larger and bold". The panel copy was hard to read at 11px/.75
                 grey. Full-black #1A1A1A, 13px, weight 600 — no opacity dimming, which is what
                 made it look washed out. The BUTTONS stay 11px: they must fit three across in the
                 ~340px slide cart, and that is the only place width is tight. */
              /* Owner: "too big or bold in the drop down · keep it short and condensed."
                 11px / weight 400, with 600 reserved for the ✓ confirmations only. The dollar
                 amounts carry <strong>, so emphasis lands on the numbers instead of the sentence. */
              var _tMut = 'display:block;text-align:center;color:#1A1A1A;font-size:11px;line-height:1.45;font-weight:400;';
              var _tWin = 'display:block;text-align:center;color:#1A1A1A;font-size:11px;line-height:1.45;font-weight:600;';

              /* Condensed (owner). Accent carries the payoff figure; the sentence stays plain. */
              var _tAcc = 'color:#B34518;font-weight:700;';   /* #EB673C fails contrast as text */
              var _tOk = '<span style="color:#1E7A4B;font-weight:700;">✓</span> ';
              /* 1 ── freight */
              var _tFrt;
              if (_dpFree) _tFrt = '<span style="' + _tWin + '">' + _tOk + 'Delivery is a <span style="' + _tAcc + '">flat rate</span> for your zone.</span>';
              else if (_belowMin) _tFrt = '<span style="' + _tMut + '">Orders start at <span style="' + _tAcc + '">' + money(50000) + '</span>.</span>';
              else if (_tMix) _tFrt = '<span style="' + _tMut + '">Both lanes are charged:</span>' +
                '<span style="' + _tMut + '">' + _tQSn + ' only <span style="' + _tAcc + '">' + money(_tQS) + '</span> · saves ' + money(_tCR) + '</span>' +
                '<span style="' + _tMut + '">' + _tCRn + ' only <span style="' + _tAcc + '">' + money(_tCR) + '</span> · saves ' + money(_tQS) + '</span>';
              else if (_tCraneOnly) {
                /* Two stacked lines, mirroring the speed block below. The saving is stated
                   because the panel is titled "Save on Freight" — owner 2026-09-17:
                   "save on freight in the PDP formatting a bit confusing". */
                /* Owner 2026-09-17: "its quite busy" / "we dont need to say unframed" / "or
                   save $50" — so two bare lines, lane and price, nothing else. */
                _tFrt = '<span style="' + _tMut + '">' + _tCRn + ' &mdash; <span style="' + _tAcc + '">' + money(_tCR) + '</span></span>' +
                  '<span style="' + _tWin + '">' + _tQSn + ' &mdash; <span style="' + _tAcc + '">' + money(_tQS) + '</span></span>';
              }
              else _tFrt = '<span style="' + _tWin + '">' + _tOk + 'Lowest freight already — <span style="' + _tAcc + '">' + money(_tQS) + '</span></span>';
              if (!_belowMin && !_dpFree && _dpChasing && _dpShort > 0) {
                /* ⭐ FREE-DELIVERY PROGRESS BAR (2026-09-18) — the "PDP slider" pushing to free
                   shipping. Rendered here because _dpShort / _dpFreeAt / cartTotal are already
                   computed and the nudge text already lands here; the standalone
                   bb-free-progress.js asset is orphaned (no loader, no mount points).
                   ⛔ Use display:block SPAN elements only. This string is appended inside a SPAN,
                      so a DIV element here is invalid markup and the browser hoists it out of its
                      container, stranding the bar elsewhere on the page. */
                var _pct = (_dpFreeAt > 0) ? Math.max(0, Math.min(100, (cartTotal / _dpFreeAt) * 100)) : 0;
                _tFrt += '<span style="' + _tMut + 'margin-top:3px;">Add <span style="' + _tAcc + '">' + money(Math.ceil(_dpShort / 100) * 100) + '</span> for free delivery</span>'
                  + '<span style="display:block;height:6px;border-radius:99px;background:rgba(0,0,0,.10);overflow:hidden;margin-top:6px;">'
                  +   '<span style="display:block;height:100%;width:' + _pct.toFixed(1) + '%;border-radius:99px;background:#EB673C;transition:width .45s ease;"></span>'
                  + '</span>';
              }

              /* 2 ── speed */
              var _tSpd;
              if (_tSame) _tSpd = '<span style="' + _tWin + '">' + _tOk + 'All lanes arrive <span style="' + _tAcc + '">' + _tLw + '</span></span>';
              else if (!_tMix && !_tCraneOnly) _tSpd = '<span style="' + _tWin + '">' + _tOk + 'Fastest lane already — <span style="' + _tAcc + '">' + _tLw + '</span></span>';
              /* Owner: on a MIXED cart, recommend the Loose Truck explicitly. A mixed cart travels
                 at the SLOWER lane, so naming both dates is the whole argument. */
              else if (_tMix) _tSpd = '<span style="' + _tMut + '">Mixed ships at the slower lane · ' + _tCw + '</span>' +
                '<span style="' + _tWin + '">' + _tQSn + ' items alone arrive <span style="' + _tAcc + '">' + _tLw + '</span></span>';
              else _tSpd = '<span style="' + _tMut + '">' + _tCRn + ' · ' + _tCw + '</span>' +
                '<span style="' + _tWin + '">Unframed ships ' + _tQSn + ' · <span style="' + _tAcc + '">' + _tLw + '</span></span>';

              /* 3 ── product. _dpDisc/_dpPay are in scope HERE and not earlier — see header. */
              /* Lead with the SAVING, not just the landed total — the shopper should not have to
                 subtract to see what the discount is worth. Same convention as the savings strip
                 above the panel, which states the dollar amount rather than only the percentage.
                 Both figures derive from cartTotal so they cannot disagree with it. */
              var _tPrd = '';
              if (_dpDisc > 0) _tPrd += '<span style="' + _tMut + '">Pay by ' + _dpPay + ' · save <span style="' + _tAcc + '">' + money(Math.round(cartTotal * _dpDisc)) + '</span> &rarr; <span style="' + _tAcc + '">' + money(Math.round(cartTotal * (1 - _dpDisc)) + _dpR) + '</span> all-in</span>';
              if (window.BB_BUCKS && window.BB_BUCKS.enabled && typeof window.BB_BUCKS.rate === 'number' && window.BB_BUCKS.rate > 0)
                _tPrd += '<span style="' + _tMut + '">Plus <span style="' + _tAcc + '">' + money(Math.round(cartTotal * window.BB_BUCKS.rate)) + '</span> back in BarrierBucks</span>';

              /* Side by side (owner): the three buttons sit in one flex row and the panels render
                 BELOW it at full width. That rules out sibling traversal — a panel is no longer
                 adjacent to its button — so each button finds its panel by class, scoped with
                 closest('.bb-ship-togs'). ⛔ An unscoped document.querySelector would hit the
                 PDP's copy from inside the cart drawer: the same markup renders in all three
                 contexts. Opening one closes the others — three panels open at once in a ~380px
                 column pushes the price off a phone screen. */
              var _tBtn = function (id, label, body) {
                if (!body) return '';
                return '<button type="button" aria-expanded="false" data-bb-tog="' + id + '" onclick="' +
                  'var r=this.closest(\'.bb-ship-togs\');' +
                  'var me=r.querySelector(\'.bb-tog-\'+this.getAttribute(\'data-bb-tog\'));' +
                  'var o=me.style.display===\'none\';' +
                  'r.querySelectorAll(\'[class^=bb-tog-]\').forEach(function(p){p.style.display=\'none\';});' +
                  'r.querySelectorAll(\'[data-bb-tog]\').forEach(function(b){b.setAttribute(\'aria-expanded\',\'false\');var c=b.querySelector(\'[data-bb-caret]\');if(c)c.textContent=\'▾\';});' +
                  'if(o){me.style.display=\'block\';this.setAttribute(\'aria-expanded\',\'true\');var c2=this.querySelector(\'[data-bb-caret]\');if(c2)c2.textContent=\'▴\';}" ' +
                  'style="background:none;border:0;padding:0;margin:0;cursor:pointer;font:inherit;font-size:11px;font-weight:600;color:inherit;text-decoration:underline;text-underline-offset:2px;display:inline-flex;align-items:center;gap:2px;white-space:nowrap;flex:0 1 auto;min-width:0;">' +
                  label + ' <span data-bb-caret style="font-size:9px;">▾</span></button>';
              };
              var _tPan = function (id, body) {
                return body ? '<span class="bb-tog-' + id + '" style="display:none;margin-top:6px;">' + body + '</span>' : '';
              };
              /* nowrap + space-between keeps all THREE on one line in the slide cart (~340px),
                 where flex-wrap:wrap was breaking them 2 + 1. Padding is tighter than the panel's
                 for the same reason — every pixel is width for the third label. */
              /* Measured in the live drawer: at 271px the three labels need 281px, so they were
                 being SHRUNK and clipped (scrollWidth > clientWidth on all three) rather than
                 wrapped — invisible in a screenshot, but the labels were losing their last pixels.
                 Reclaiming 12px from gap (8->4) and padding (10->8) clears the 10px shortfall
                 without touching the type size. */
              /* Owner: "a bit of a background hue". Faint warm tint keyed to the brand accent —
                 the same family as the orange delivery box above, at a fraction of the strength so
                 it reads as a distinct section without competing with the price. */
              /* ⛔ OWNER 2026-09-26: the three toggles are REMOVED from the cart. Flip
                 BB_SHOW_SHIP_TOGS back to true to restore them — the builders and panel bodies
                 below are intentionally left intact so nothing else has to be rebuilt. */
              var BB_SHOW_SHIP_TOGS = false;
              if (BB_SHOW_SHIP_TOGS) _bbTogs = '<div class="bb-ship-togs" style="padding:9px 8px 10px;border-top:1px solid rgba(235,103,60,.18);background:rgba(235,103,60,.05);border-radius:0 0 10px 10px;text-align:center;">' +
                '<span style="display:flex;justify-content:space-between;align-items:center;gap:4px;flex-wrap:nowrap;">' +
                  _tBtn('frt', 'Save on Freight', _tFrt) + _tBtn('spd', 'Get it Quicker', _tSpd) + _tBtn('prd', 'Save on Product', _tPrd) +
                '</span>' +
                _tPan('frt', _tFrt) + _tPan('spd', _tSpd) + _tPan('prd', _tPrd) +
                '</div>';
            }
          } catch (_te) { _bbTogs = ''; }
          _dpHero = '<div class="bb-ship-allin' + (_dpFree ? ' bb-ship-allin--free' : '') + '">' +
            /* ⭐ ETA MOVED INSIDE THE DELIVERY BOX (owner 2026-09-30). It sat ABOVE the price, so the headline
               number was the fourth thing read. City, date and rate are one subject — one place. */
            '<span class="bb-ship-allin__label" style="margin-top:0"><span class="bb-ship-allin__dl">' + _bbEtaLn + '</span></span>' +
            _dpPriceCap + _dpHint +
            /* ⭐ SLIDER SITS UNDER THE BANK-DEPOSIT HINT AND ABOVE THE BARRIERBOSS/Others
               comparison (owner 2026-10-26). Order only — nothing is rebuilt. */
            /* ⛔ SLIDER REMOVED 2026-10-26 — the freight tiers now live inside the delivery box
               (see _dpBreak). Two surfaces stating the same ladder is what made the card messy. */
            '<span class="bb-ship-allin__label"><span class="bb-ship-allin__dl">' + _dpDelivered + '</span></span>' +
            _bbTogs +
            '</div>';
        }
      } catch (_e) {}
      { /* ⛔ 2026-10-16: the zone gate is GONE. It hid the card title everywhere outside the old west zones — a Florida or Ontario shopper saw an untitled card. The title is a brand statement, not a regional one. */
        homeownerBadge = '<div class="bb-ship-homeowner-badge" style="display:flex;align-items:center;gap:8px;margin-top:6px;font-size:10px;font-weight:600;color:#000;letter-spacing:0.8px;text-transform:uppercase;margin-bottom:0px;"><span style="flex:1;height:1px;background:rgba(0,0,0,0.15);"></span><span style="color:#EB673C;font-size:12px;">★</span><span style="text-align:center;"><span style="display:block;font-size:11px;font-weight:700;letter-spacing:1.2px;color:#333;white-space:nowrap;">Made, Moved &amp; Unloaded by Us</span></span><span style="color:#EB673C;font-size:12px;">★</span><span style="flex:1;height:1px;background:rgba(0,0,0,0.15);"></span></div>';
      }
      // Delivery line is MERGED into the hero label when the hero shows. Only
      // when there's no hero (cart < $500, no rate yet) do we fall back to the
      // standalone "BARRIERBOSS Residential Delivery · [town] · change · ETA" row so the
      // location/ETA/change control isn't lost.
      var _fallbackDelivery = '<div class="bb-ship-header__line"><span class="bb-ship-header__zone">BARRIERBOSS Residential Delivery · <span class="bb-ship-header__loc">' + locationStr + '</span> <a href="#" class="bb-ship-change" data-bb-reset>change</a></span><span class="bb-ship-header__arrival">ETA <strong class="bb-ship-header__loc">' + _etaStr + '</strong></span></div>';
      headerEl.innerHTML = homeownerBadge + _dpHero + (_dpHero ? '' : _fallbackDelivery);
    }

    var _trustEl = document.getElementById('bb-ship-trust-' + ctx);
    if (_trustEl) _trustEl.innerHTML = _subline + (ctx === 'product' ? '' : _trustBadges); // BarrierBucks moved OUT of the estimator to its own cart-drawer card (owner 2026-07)

    // === DELIVERY — empty (arrival moved to header) ===
    deliveryEl.style.display = 'none';

    // Fire GA4 view event (once per context per page load)
    if (!el.dataset.ga4Viewed) {
      el.dataset.ga4Viewed = '1';
      ga4Event('bb_estimator_view', {
        context: ctx, zone: geoZone, state: geoState, cart_total: cartTotal / 100
      });
    }

    el.style.display = 'block';
    // Mutual exclusion: the estimator is now visible for this context, so hide
    // its postal-code fallback. Prevents the "estimator + postal bar double-up"
    // — a geo failure or drawer re-render could have revealed the fallback, and
    // nothing else hid it once geo later resolved (only a hard refresh did).
    // querySelectorAll guards against any duplicate fallback node in the drawer.
    var _zEls = document.querySelectorAll('[id="bb-ship-zip-' + ctx + '"]');
    for (var _zi = 0; _zi < _zEls.length; _zi++) _zEls[_zi].style.display = 'none';
  }

  function renderAll(cartTotal) {
    renderElement('product', cartTotal);
    renderElement('cart', cartTotal);
    renderElement('cartpage', cartTotal);
    // Publish current shipping rate so PDP fence calculator can show a
    // "Delivered Material Cost / linear foot" number that includes freight.
    try {
      // Same lane-aware rule as the notice above: only suppress the rate when the region is
      // genuinely unserved, or when the cart needs a crane that can't reach it. A Loose Truck
      // cart into zones 3/4/7 must publish a REAL rate so the PDP and FOB show it.
      // The Crane profile reaches only the Express zones. Where Loose Truck opened on 2026-08-12
      // crane did NOT, and CRANE_RATES has no entry there — so both branches below were skipped
      // and consumers kept displaying the PREVIOUS cart's rate. A stale number for an impossible
      // checkout is worse than silence.
      var _bbCraneUnreachable = !!(bbCraneNow() && geoZone && !bbCraneServed(geoZone));
      if (geoState && (UNSERVED_STATES[geoState] || _bbCraneUnreachable || (bbCraneNow() && CRANE_PAUSED_STATES[geoState]))) {
        document.dispatchEvent(new CustomEvent('bb:ship-rate', {
          detail: { rateCents: null, label: null, zone: geoZone, atFree: false, cartTotal: cartTotal, paused: true,
                    craneBlocked: !!((_bbCraneUnreachable || (bbCraneNow() && CRANE_PAUSED_STATES[geoState])) && !UNSERVED_STATES[geoState]),
                    quickShipAvailable: !!(ZONES[geoState] && !UNSERVED_STATES[geoState]) }
        }));
      } else if (geoZone && bbRates()[geoZone]) {
        var tiers = bbRates()[geoZone];
        var idx = getCurrentTierIndex(geoZone, cartTotal);
        var rateCents = (idx >= 0 && idx < tiers.length) ? tiers[idx].rate : null;
        var label = (idx >= 0 && idx < tiers.length) ? tiers[idx].label : null;
        document.dispatchEvent(new CustomEvent('bb:ship-rate', {
          detail: {
            rateCents: rateCents,
            label: label,
            zone: geoZone,
            atFree: rateCents === 0,
            cartTotal: cartTotal
          }
        }));
      }
    } catch(e) {}
  }

  var _bbRefreshTimer = null;
  // Debounce: coalesce rapid add/remove into ONE trailing refresh so concurrent
  // /cart.js reads can't land out of order and flicker an old total back in.
  function scheduleRefresh() {
    if (_bbRefreshTimer) clearTimeout(_bbRefreshTimer);
    _bbRefreshTimer = setTimeout(refreshFromCart, 300);
  }
  function refreshFromCart() {
    fetch('/cart.js', { cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (cart.items && cart.items.length > 0) {
          var totalQty = 0;
          for (var i = 0; i < cart.items.length; i++) {
            totalQty += cart.items[i].quantity;
          }
          if (totalQty > 0) {
            avgItemPrice = Math.round(cart.total_price / totalQty);
          }
        }
        try {
          window.__bbCartCraneKnown = true;
          window.__bbCartItemCount = (cart.items || []).length;
          window.__bbCartLanes = bbCartLanes(cart.items);
          window.__bbCartCrane = bbCartHasCrane(cart.items);
        } catch (_e) {}
        renderAll(bbFreightCents(cart)); bbApplySampleOnly(cart);
      })
      .catch(function() {});
  }

  /* Delegates to the shared resolver. If BBGeo is somehow absent this returns
     null, which routes to the postal prompt — never a guessed state, so a
     missing dependency can only cost a lookup, never quote a wrong rate. */
  function zipToState(zip) {
    if (!window.BBGeo) return null;
    var r = window.BBGeo.resolveCode(zip);
    return r ? r.region : null;
  }

  /* Reads the shared cache, then falls back to the shared IP path. The
     city-ownership rule (only trust a city stamped with THIS state) moved
     into BBGeo.get(), which applies it to BOTH stamps. ZONES stays the
     serviceability gate here — BBGeo resolves geography, this file decides
     what is served. */
  function resolveGeo(callback) {
    if (!window.BBGeo) { showZipFallback(); return; }
    var g = window.BBGeo.get();
    if (g && g.state && ZONES[g.state]) {
      geoState = g.state;
      geoCity = g.city || '';
      geoZone = ZONES[g.state];
      callback();
      return;
    }
    window.BBGeo.resolveIP(function (ip) {
      if (ip && ip.region && ZONES[ip.region]) {
        window.BBGeo.set({ region: ip.region, city: ip.city, source: 'ip' }, { silent: true });
        geoState = ip.region;
        geoCity = ip.city || '';
        geoZone = ZONES[ip.region];
        callback();
      } else {
        showZipFallback();
      }
    });
  }

  function showZipFallback() {
    var els = document.querySelectorAll('[id^="bb-ship-zip-"]');
    for (var i = 0; i < els.length; i++) els[i].style.display = 'block';
    // Mutual exclusion (other direction): geo is unknown, so no estimator block
    // should remain visible alongside the postal fallback.
    var estEls = document.querySelectorAll('[id^="bb-ship-est-"]');
    for (var j = 0; j < estEls.length; j++) estEls[j].style.display = 'none';
  }

  function handleZipClick(e) {
    var btn = e.target;
    var ctx = btn.id.replace('bb-ship-zip-btn-', '');
    var input = document.getElementById('bb-ship-zip-input-' + ctx);
    var zip = (input.value || '').trim();
    var state = zipToState(zip);

    if (!state || !ZONES[state]) return;

    geoState = state;
    geoZone = ZONES[state];
    /* ⛔ WAS A BUG: this set the state but left geoCity holding the city from
       the PREVIOUS IP lookup, so typing a Texas ZIP after an IP hit in
       Seattle rendered "Seattle, TX". BBGeo.set with no city clears the city,
       both ownership stamps and the coordinates together. */
    geoCity = '';
    if (window.BBGeo) window.BBGeo.set({ region: geoState, source: 'user' }, { silent: true });
    else sessionStorage.setItem('bb_geo_state', geoState);
    /* Then upgrade to the real city + coordinates from the lazy shard, so a
       typed ZIP reads as personally as a detected one. Silent on failure. */
    if (window.BBGeo) window.BBGeo.resolveCity(zip, geoState, function (hit) {
      if (hit && hit.city) { geoCity = hit.city; try { refreshFromCart(); } catch (e) {} }
    });

    ga4Event('bb_estimator_zip', { zip: zip, state: state, zone: geoZone });
      try { document.dispatchEvent(new CustomEvent('bb:geo-change', { detail: { state: geoState, zone: geoZone } })); } catch (e) {}

    // Hide all zip forms
    var zipEls = document.querySelectorAll('[id^="bb-ship-zip-"]');
    for (var i = 0; i < zipEls.length; i++) zipEls[i].style.display = 'none';

    // Render estimator for the context that triggered this
    if (ctx === 'cart' || ctx === 'cartpage') {
      var cartEl = document.getElementById('bb-ship-est-' + ctx);
      if (cartEl) {
        var cartTotal = parseInt(cartEl.dataset.cartTotal || '0', 10);
        renderElement(ctx, cartTotal);
      }
    } else {
      var productEl = document.getElementById('bb-ship-est-product');
      if (productEl) {
        renderElement('product', parseInt(productEl.dataset.cartTotal || '0', 10));
      }
    }
  }

  // Watch for estimator elements appearing (cart drawer AJAX rebuilds)
  var observer = new MutationObserver(function() {
    var cartEl = document.getElementById('bb-ship-est-cart');
    if (cartEl && !cartEl.dataset.rendered) {
      cartEl.dataset.rendered = '1';
      if (geoState) refreshFromCart(); else showZipFallback();
    }
    var productEl = document.getElementById('bb-ship-est-product');
    if (productEl && !productEl.dataset.rendered) {
      productEl.dataset.rendered = '1';
      if (geoState) {
        var total = parseInt(productEl.dataset.cartTotal || '0', 10);
        renderElement('product', total);
      }
    }
    // Bind zip buttons as they appear
    var zipBtns = document.querySelectorAll('[id^="bb-ship-zip-btn-"]');
    for (var i = 0; i < zipBtns.length; i++) {
      if (!zipBtns[i].dataset.bound) {
        zipBtns[i].dataset.bound = '1';
        zipBtns[i].addEventListener('click', handleZipClick);
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // "change" link — reset geo and show zip form
  document.addEventListener('click', function(e) {
    var link = e.target.closest('[data-bb-reset]');
    if (link) { e.preventDefault(); resetGeo(); }
  });

  // Intercept cart AJAX — also fire bb_atc_with_estimator
  var origFetch = window.fetch;
  window.fetch = function() {
    var url = arguments[0];
    var result = origFetch.apply(this, arguments);
    if (typeof url === 'string' && (url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/add') || url.includes('/cart/clear'))) {
      if (url.includes('/cart/add') && geoZone) {
        ga4Event('bb_atc_with_estimator', { zone: geoZone, state: geoState });
      }
      result.then(function() { scheduleRefresh(); });
    }
    return result;
  };
  var origXHROpen = XMLHttpRequest.prototype.open;
  var origXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._bbUrl = url;
    return origXHROpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function() {
    var xhr = this;
    if (xhr._bbUrl && (xhr._bbUrl.includes('/cart/change') || xhr._bbUrl.includes('/cart/update') || xhr._bbUrl.includes('/cart/add') || xhr._bbUrl.includes('/cart/clear'))) {
      if (xhr._bbUrl.includes('/cart/add') && geoZone) {
        ga4Event('bb_atc_with_estimator', { zone: geoZone, state: geoState });
      }
      xhr.addEventListener('load', function() { scheduleRefresh(); });
    }
    return origXHRSend.apply(this, arguments);
  };

  // Init
  resolveGeo(function() {
    fetch('/cart.js', { cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (cart.items && cart.items.length > 0) {
          var qty = 0;
          for (var i = 0; i < cart.items.length; i++) qty += cart.items[i].quantity;
          if (qty > 0) avgItemPrice = Math.round(cart.total_price / qty);
        }
        if (!avgItemPrice) {
          var priceEl = document.querySelector('[data-product-price], .product__price .money, .product-single__price .money');
          if (priceEl) {
            var priceText = priceEl.textContent.replace(/[^0-9.]/g, '');
            var price = parseFloat(priceText);
            if (price > 0) avgItemPrice = Math.round(price * 100);
          }
        }
        var productEl = document.getElementById('bb-ship-est-product');
        if (productEl) {
          var anchor = document.querySelector('product-form');
          if (anchor) anchor.after(productEl);
          renderElement('product', parseInt(productEl.dataset.cartTotal || '0', 10));
        }
        var cartEl = document.getElementById('bb-ship-est-cart');
        var cartPageEl = document.getElementById('bb-ship-est-cartpage');
        if (cartEl || cartPageEl) renderAll(bbFreightCents(cart)); bbApplySampleOnly(cart);
      })
      .catch(function() {
        var productEl = document.getElementById('bb-ship-est-product');
        if (productEl) renderElement('product', parseInt(productEl.dataset.cartTotal || '0', 10));
        var cpEl = document.getElementById('bb-ship-est-cartpage');
        if (cpEl) renderElement('cartpage', parseInt(cpEl.dataset.cartTotal || '0', 10));
      });
  });

  // BB Calculator integration — when the on-PDP fence calculator computes a
  // build, re-render the shipping estimator with (cart total + calc subtotal)
  // so the "add $X to reach minimum" tier reflects what the customer is
  // actively building, not their empty cart.
  // SO state comes from bb-mesh-swap (single source of truth) so the estimator
  // and the SO widget can never disagree. Re-render when it flips.
  document.addEventListener('bb:so-state', function(e){
    var so = !!(e && e.detail && e.detail.isSO);
    if (so === bbSO) return;
    bbSO = so;
    try { refreshFromCart(); } catch(_){}
  });

  /* ⭐ LIVE CART (owner 2026-10-26: "slider doesn't update without a refresh"). refreshFromCart()
     already existed and already did the right thing — nothing called it on an add, a remove or a
     quantity change, so the rail kept quoting a gap the shopper had already closed.
     ⛔ No single cart event covers the theme, the drawer and the steppers, so: hook fetch on
        /cart/ mutations, plus the usual custom events, plus tab focus. URL is read, nothing else
        is touched. Re-renders only on a CHANGED total, so it cannot flicker-loop. */
  (function () {
    var _bbLastTotal = null;
    function _bbCartRefresh() {
      try {
        fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (c) {
            if (!c || typeof c.total_price !== 'number') return;
            if (c.total_price === _bbLastTotal) return;
            _bbLastTotal = c.total_price;
            try { refreshFromCart(); } catch (_) {}
          })
          .catch(function () {});
      } catch (e) {}
    }
    try {
      if (!window.__bbEstCartHook) {
        window.__bbEstCartHook = 1;
        var _oF = window.fetch;
        if (typeof _oF === 'function') {
          window.fetch = function () {
            var _a = arguments, _u = '';
            try { _u = (typeof _a[0] === 'string') ? _a[0] : ((_a[0] && _a[0].url) || ''); } catch (e) {}
            var _p = _oF.apply(this, _a);
            try {
              if (/\/cart\/(add|change|update|clear)/i.test(_u)) _p.then(function () { setTimeout(_bbCartRefresh, 180); }, function () {});
            } catch (e) {}
            return _p;
          };
        }
      }
    } catch (e) {}
    try {
      var _evs = ['bb:cart-updated', 'cart:updated', 'cart:refresh', 'cart:change', 'ajaxCart.afterCartLoad'];
      for (var _i = 0; _i < _evs.length; _i++) document.addEventListener(_evs[_i], function () { setTimeout(_bbCartRefresh, 100); });
      window.addEventListener('focus', _bbCartRefresh);
      window.addEventListener('pageshow', _bbCartRefresh);
    } catch (e) {}
  })();

  var bbCalcExtraCents = 0;
  document.addEventListener('bb:calc-quote', function(e) {
    bbCalcExtraCents = (e.detail && e.detail.totalCents) || 0;
    fetch('/cart.js', { cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderAll(bbFreightCents(cart) + ((cart.item_count > 0) ? 0 : bbCalcExtraCents)); bbApplySampleOnly(cart); })
      .catch(function() { renderAll(bbCalcExtraCents); });
  });

  // A ZIP/postal entered in the announcement bar writes bb_geo_state and fires bb:geo-change.
  // Geo is resolved ONCE at init into geoState/geoCity/geoZone, so without this the PDP hero
  // and the slide-cart keep showing the previous location and price until a page reload.
  // Handles CLEAR as well as set — "change" empties the stored location.
  document.addEventListener('bb:geo-change', function () {
    try {
      /* Read through BBGeo so the city-ownership stamp is enforced. A raw
         bb_geo_city read here was the last path that could pair a city with
         the wrong state after a banner ZIP entry. */
      var _g = window.BBGeo ? window.BBGeo.get() : null;
      var st = _g ? _g.state : sessionStorage.getItem('bb_geo_state');
      var cty = _g ? (_g.city || '') : '';
      if (st && ZONES[st]) { geoState = st; geoCity = cty; geoZone = ZONES[st]; }
      else { geoState = null; geoCity = null; geoZone = null; }
      refreshFromCart();
    } catch (e) {}
  });
})();



/* ⭐ COLLAPSED TWO-TRUCK FLAG (owner 2026-10-26: "has to be collapsed").
   ⛔ Delegated, not inline: the estimator re-renders this card on every cart and geo change, so a
      handler bound to the button would die with the node. Attached once, at document level. */
(function () {
  if (window.__bbMixToggle) return;
  window.__bbMixToggle = 1;
  document.addEventListener('click', function (e) {
    var t = (e.target && e.target.closest) ? e.target.closest('[data-bb-mixtoggle]') : null;
    if (!t) return;
    e.preventDefault();
    var b = t.nextElementSibling;
    if (!b) return;
    var o = b.style.display === 'none';
    b.style.display = o ? 'block' : 'none';
    t.setAttribute('aria-expanded', o ? 'true' : 'false');
    var c = t.querySelector('[data-bb-mixcaret2]');
    if (c) c.textContent = o ? '▴' : '▾';
  });
})();




